const translationsUk = {
    "status": "success",
    "data": {
        "lang": "en_US",
        "app": "hotel",
        "translation": {
            "liveBooking": {
  bookingMovedToOperationsMessage:
    'Ваше бронювання успішно оброблено та передано нашій операційній команді для підтвердження постачальником.',
  pleaseWaitSupplierApproval:
    'Будь ласка, зачекайте, поки постачальник розгляне та підтвердить ваше бронювання. Зазвичай це займає кілька годин.',

  waitingSupplierApproval: 'ОЧІКУЄ ПІДТВЕРДЖЕННЯ ПОСТАЧАЛЬНИКОМ',
  youWillBeNotified:
    'Ви отримаєте сповіщення електронною поштою, щойно постачальник відповість.',
                  "processingYourBooking": "Обробка вашого бронювання...",
            "stepCompletedSuccessfully": "Крок успішно завершено",
            "somethingWentWrongOurTeamIsWorkingOnIt": "Щось пішло не так. Наша команда вже працює над цим.",
            "stepCouldNotBeCompleted": "Не вдалося завершити крок.",
            "stillProcessingPleaseWait": "Обробка триває, будь ласка, зачекайте...",
            "waitingForSupplierApproval": "Очікування підтвердження постачальника",
            "stepAlreadyCompleted": "Крок уже завершено.",
            "REVALIDATE": "Повторна перевірка",
            "RESERVATION": "Бронювання",
            "SUMMARY": "Підсумок",
            "PAYMENT_FINALIZATION": "Завершення оплати",
            "bookingProcessStatus": "Статус процесу бронювання",
            "order": "Замовлення",
            "lastUpdate": "Останнє оновлення",
            "liveStreamingNotAvailable": "Пряма трансляція недоступна — використовується резервне опитування. Якщо проблема зберігається, наша операційна команда перевіряє ситуацію.",
            "noProgressAvailable": "Наразі немає інформації про прогрес бронювання.",
            "paymentNotRequired": "Оплата не потрібна для цього бронювання (обрано опцію «Оплатити пізніше»)",
            "paymentProcessed": "Оплату оброблено",
            "transactionId": "ID транзакції:",
            "processingOrderLevelJob": "Обробка завдання на рівні замовлення",
            "emailSentToCustomer": "Лист надіслано клієнту",
            "status": "СТАТУС",
            "retries": "СПРОБИ",
            "eta": "ОРІЄНТОВНИЙ ЧАС",
            "timestamp": "ЧАСОВА МІТКА",
            "processing": "В обробці",
            "currentAttempt": "ПОТОЧНА СПРОБА",
            "of": "з",
            "failedToProcess": "Не вдалося обробити",
            "supplierApiDidNotRespond": "API постачальника не відповів у дозволений час.",
            "attempts": "СПРОБИ",
            "duration": "ТРИВАЛІСТЬ",
            "failedAt": "ПОМИЛКА НА",
            "retryAvailable": "Повторна спроба доступна",
            "retryStep": "Повторити крок",
            "waitingForRetry": "Очікування повторної спроби після тимчасової проблеми.",
            "etaForRetry": "Орієнтовний час повторної спроби:",
            "awaitingPreviousStep": "Очікування завершення попереднього кроку",
            "paymentWillBeProcessed": "Оплата буде оброблена далі",
            "emailQueued": "Сповіщення електронною поштою поставлено в чергу",
            "willBeSentAfterPayment": "Буде надіслано після підтвердження оплати",
            "processFailedAtStep": "Процес завершився помилкою на кроці",
            "processingStep": "Обробка кроку",
            "system": "Система",
            "bookingConfirmed": "Бронювання підтверджено!",
            "orderApprovedSuccessfully": "Ваше замовлення успішно схвалено.",
            "sentItineraryToEmail": "Ми надіслали маршрут на вашу електронну пошту.",
            "orderConfirmed": "Замовлення підтверджено",
            "allSystemsGo": "Усі системи працюють!",
            "orderNumber": "Номер замовлення",
            "confirmation": "Підтвердження",
            "sentToEmail": "Надіслано на електронну пошту",
            "checkYourInbox": "Перевірте вхідні",
            "completeItinerarySent": "Повний маршрут і деталі бронювання надіслано на вашу зареєстровану електронну адресу.",
            "orderBeingProcessed": "Ваше замовлення наразі обробляється.",
            "orderWaitingForSupplier": "Ваше замовлення наразі очікує на схвалення постачальника.",
            "errorProcessingStep": "Під час обробки цього кроку сталася помилка.",
            "pending": "в очікуванні",
            "awaitingProcessing": "Очікує обробки.",
            "skipped": "пропущено",
            "stepNotRequired": "Цей крок не був потрібний для вашого бронювання.",
            "completed": "завершено",
            "processSteps": "Кроки процесу",
            "stepsCompletedSuccessfully": "кроки успішно виконані",
            "allDone": "Готово",
            "failed": "Помилка",
            "inProgress": "В процесі",
            "loadingStatus": "Завантаження статусу",
            "okay": "Гаразд",
            "approved": "Схвалено"
            },

            "crud": {
                "updatedSuccessfully": "Успішно оновлено",
                "validationFailed" : "Перевірка не пройшла",
                "fieldRequired": "Обов'язкове поле",
                "operationError" : "Виникла помилка",
                "emptyList" : "Дані не знайдено",
                "failToLoad" : "Помилка завантаження",
                "modelNotFound" : "Не знайдено",
            },
            "updateCard": {
                "payment_failed_please_update_card": "Payment failed - please update card",
                "open_the_payment_form": "Open the payment form",
            },
            "auth": {
                authTypeWarning: 'Будь ласка, зверніться до операційної команди, щоб увімкнути членство — тип автентифікації не визначено',
                authTitle: "Аутентифікація за допомогою ID та мобільного телефону",
                pleaseLogin: "Будь ласка, увійдіть з вашими обліковими даними",
                verify: "Підтвердити",
                id: "Ідентифікатор",
                idPlaceholder: "Введіть ваш ідентифікатор",
                idPlaceholderError: "Будь ласка, введіть ваш ідентифікатор",
                idDigits: "Ідентифікатор повинен містити 9 цифр",
                phone: "Телефон",
                phonePlaceholderError: "Будь ласка, введіть ваш номер телефону",
                phoneDigits: "Номер телефону повинен містити 9 цифр",
                phonePlaceholder: "Введіть ваш номер телефону",
                send: "Надіслати",
                authModalTitle: "Аутентифікація за ідентифікатором та мобільним телефоном",
                loginLoaeder: "Вхід у систему...",
                loginError: "Не вдалося увійти. Будь ласка, спробуйте ще раз.",
                otpLoader: "Перевірка одноразового пароля...",
                loginSuccess: "Успішний вхід",
                otpError: "Не вдалося перевірити одноразовий пароль. Будь ласка, спробуйте ще раз.",
                otpStartOver: "Не отримали код? Почніть спочатку",
                register: "Реєстрація",
                firstName: "Ім'я",
                lastName: "Прізвище",
                email: "Електронна пошта",
                firstNamePlaceholder: "Введіть ваше ім'я",
                lastNamePlaceholder: "Введіть ваше прізвище",
                emailPlaceholder: "Введіть вашу електронну пошту",
                firstNamePlaceholderError: "Будь ласка, введіть ваше ім'я",
                lastNamePlaceholderError: "Будь ласка, введіть ваше прізвище",
                emailPlaceholderError: "Будь ласка, введіть вашу електронну пошту",
                emailInvalid: "Будь ласка, введіть дійсну адресу електронної пошти",
                nameMinLength: "Ім'я повинно містити принаймні 2 символи",
                registerButton: "Зареєструватися",
                backToLogin: "Повернутися до входу",
                registrationSuccess: "Реєстрація успішна",
                registrationSuccessMessage: "Ваша реєстрація пройшла успішно",
                registrationError: "Реєстрація не вдалася. Будь ласка, спробуйте ще раз.",
                dontHaveAccount: "Не маєте аккаунта?",
                registerHere: "Зареєструватися тут",
                authWithMobile: "Аутентифікація з мобільним телефоном",
                registerWithMobile: "Реєстрація з номером мобільного телефону",
                loginTitle: "Увійдіть, щоб продовжити",
                loginDescription: "Щоб забронювати або керувати замовленням, підтвердіть свій номер телефону. Це займе менше хвилини.",
                otpInfo: "Ми надішлемо одноразовий код (OTP). Пароль не потрібен.",
                whyLogin: "Навіщо мені входити?",
                newHere: "Новий тут?",
                createAccount: "Створити обліковий запис",
                sendCode: "Надіслати код",
                privacyNotice: "Ми ніколи не передамо ваш номер. Можуть застосовуватися тарифи SMS.",
                mobileNumber: "Номер мобільного",
                accountNotFound: "Обліковий запис не існує",
                continueWithRegistration: "Бажаєте продовжити реєстрацію?",
                continueRegistration: "Продовжити реєстрацію",
                cancel: "Скасувати",
                registrationStepIndicator: "КРОК 2 З 2 — ВВЕДІТЬ ДАНІ",
                createYourAccount: "Створіть обліковий запис",
                registrationDescription: "Створіть обліковий запис для швидшого бронювання та відстеження замовлень.",
                mobileHelper: "Ми використаємо його для надсилання коду підтвердження.",
                emailHelper: "Необов'язково — для отримання ваучерів та оновлень.",
                agreeToTerms: "Я погоджуюсь з",
                terms: "Умовами",
                and: "та",
                privacyPolicy: "Політикою конфіденційності",
                alreadyHaveAccount: "Вже є обліковий запис?",
                logIn: "Увійти",
                agreeToTermsError: "Будь ласка, погодьтеся з умовами та політикою конфіденційності",
                subscribeNewsletter: "Підпишіться на нашу новинарку",
                newsletterEmailRequired: "Будь ласка, введіть вашу електронну пошту, щоб підписатися на новинарку",
                updateProfile: "Оновити профіль",
                logout: "Вийти",
                updateProfileSuccess: "Профіль оновлено",
                updateProfileSuccessMessage: "Ваш профіль успішно оновлено.",
                updateProfileError: "Не вдалося оновити профіль. Спробуйте ще раз.",
                close: "Закрити",
            },

            "upgradePlan": {
                "general": {
                    "upgrade_plan": "План оновлення",
                    "upgrade_plan_to_regular": "Оновити до звичайного плану",
                    "upgrade_plan_to_pro": "Оновити до плану PRO",
                  },
                "regular": {
                    "title": "Оновіть зараз і отримайте доступ до продуктів Agent 360!",
                    "benefits_title_text": "Ви наразі підключені до пакету Agent 360 Light, якщо ви оновите, ви зможете отримати",
                    "text_1": "Оптові продукти Sky 360",
                    "text_2": "Готелі для всіх напрямків по всьому світу",
                    "text_3": "Регулярні та бюджетні рейси",
                    "text_4": "Атракції по всьому світу",
                    "button_text": "Оновіть зараз до Agent 360!"
                },
                "pro": {
                    "title": "Оновіть зараз і отримайте вебсайт для вашого бізнесу з повним брендуванням!",
                    "benefits_title_text": "У пакеті SKY 360 Pro ви можете насолоджуватися",
                    "text_1": "Вебсайт з унікальним доменом",
                    "text_2": "Брендування бізнесу - логотип та кольори сайту",
                    "text_3": "Просування пакетів та рейсів на сайті за напрямками",
                    "text_4": "Усі зроблені бронювання будуть належати вашій агенції!",
                    "button_text": "Оновіть зараз до Pro!"
                }
            },
            "attractionQuestions": {
                "customerInfo": "Customer Info",
                "participantsInfo": "Participants Info",

                "first_name": "First Name",
                "last_name": "Last Name",
                "email_address": "Email Address",
                "phone_number": "Phone Number",
                "pickup_location": "Pickup Location",
                "height_in_centimeters": "Height in Centimeters",
                "weight_in_kilograms": "Weight in Kilograms",
            },
            "contactUs": {
                "email": "Електронна пошта",
                "phone": "Телефон",
                "fullName": "Повне ім'я",
                "writeUsMessage": "Напишіть нам повідомлення",
                "send": "Відправити",
                "phoneRequired": "Будь ласка, введіть номер телефону",
                "emailRequired": "Будь ласка, введіть адресу електронної пошти",
                "fullNameRequired": "Будь ласка, введіть повне ім'я",
                "messageRequired": "Будь ласка, введіть повідомлення",
                "nameMinLength": "Ім'я має містити принаймні 2 символи",
                "emailInvalid": "Будь ласка, введіть дійсну адресу електронної пошти",
                "subjectRequired": "Будь ласка, виберіть тему",
                "selectSubject": "Виберіть тему",
                "messageMin": "Повідомлення має містити принаймні 10 символів",
                "aboutUs": "Про нас"
            },
            "cart": {
                "addToCart": "Додати до кошика",
                "select": "Вибрати",
                "remove": "Видалити",
            },
            "customerSupport": {
                "customerService": "Customer Service",
                "sendMessageAndGetNotified": "Send us a message and the auctioneer will get back to you as soon as possible",
                "callUs": "Call us: ",
            },
            "roomInfo": {
                "info": "Опис номера",
                "viewAllThePhotos": "Переглянути всі фотографії",
                "roomSize": "Розмір номера (кв. м)",
                "peopleInTheRoom": "Люди в номері",
                "doubleBed": "Двоспальне ліжко"
            },
            "conceptsList":{
                "conceptsListTitle": "Concepts List Title",
                "includesActivities": "Gift attractions",
                "includesActivity": "Includes a gift attraction",
                "includeInPackage": "Includes In Package",
                "transfer": "Transfer",
                "includesTransfer": "Включає трансфер",
                "transferContent": "HOS transfers at the price of the package",
                "baseBoard": "Base Board",
                "autoApprove": "Auto Approve",
                "airways": "Airways",
                "flightFrom": "Flight From",
                "flightBack": "Flight Back",
                "toOrder": "To Order",
                "selectFlight": "Select A Flight",
                "reselectFlight": "Reselect Flights",
                "flightCanBeReSelectedNextPage": "Flight can be re-selected in the next page",
                "flightSelectedSuccessfully": "Flight Selected Successfully",
                "nights": "Nights",
                "numberOf": "Number of",
                "noPackagesFound": "No Package Found",
                "moreDeals":"אופציות נוספות",
                "pricePerPerson":"Price Per Person",
            },
            "wallet":{
                future: "Нереалізований прибуток",
                creditCard:"Кредитна картка",
                cancel: "Скасувати",
                forConfirmationRedemption: "Ви впевнені, що хочете обміняти діаманти?",
                TotalDiamondsYouWillReceive: "Загальна кількість діамантів, яку ви отримаєте",
                max: "Максимум",
                currentOrderTotal: "Загальна сума поточного замовлення",
                MaximumRedeemable: "Максимальна сума для викупу:",
                UseMax: "Використати максимум",
                Apply: "Застосувати",
                Applying: "Застосування...",
                RedeemDiamonds: "Викупити діаманти",
                RemainingDiamonds: "Залишок діамантів",
                DiscountedValue: "Значення зі знижкою",
                RedeemedAmount: "Сума, що викуплена",
                Redeemed: "Викуплено",
                totalValue: "Загальна вартість",
                diamondsRate: "1 діамант = 1 ILS",
                availableDiamonds: "Доступні діаманти",
                diamondBalance: "Баланс діамантів",
                discount: "знижка",
                Subtotal: "Проміжний підсумок",
                paymentDetails: "Деталі оплати",
                totalPayment: "Загальна сума до оплати:",
                "wallet": "Гаманець",
                "walletTransactions": "Транзакції гаманця",
                "walletBalance": "Баланс гаманця",
                "diamonds": "діаманти",
                "diamondsAreAvailableAtYourDisposal": "діаманти доступні у вашому розпорядженні",
                "paymentWithDiamonds": "Оплата діамантами",
                "returnToOrderManagement": "Повернутися до управління замовленнями",
                "reserve": "Резерв",
                "finalize": "Завершити",
                "release": "Звільнити",
                "partialRealization": "Часткова реалізація",
                "fullRealization": "Повна реалізація",
                "selectNumberOfDiamondsForPartialUse": "Виберіть кількість діамантів для часткового використання",
                "useAllTheDiamondsIHave": "Використати всі діаманти, які у мене є",
                "save": "зберегти",
                "confirm": "підтвердити",
                "forConfirmation": "для підтвердження",
                "totalAgentFee": "Загальна комісія агента",

                "dynamicLabels": {
                    'availableDiamondsForPayment': `У вас є #{amount} діамантів, доступних для оплати, вартістю #{price}`,
                    'XOfDiamondsWorthY': `#{amount} діамантів, вартістю #{price}`,
                    'totalDiamondsYouHaveAccumulatedOverTheLast12MonthsAsOfToday': `Загальна кількість діамантів, які ви накопичили за останні 12 місяців станом на сьогодні`,
                  },
            },
            "viewFlight": {
                "selected": "Вибрано",
                "pleaseSelectDestinationAirport": "Будь ласка, виберіть аеропорт прибуття",
                "noNearbyAirportFound": "Не знайдено близького аеропорту. Будь ласка, знайдіть аеропорт і переконайтеся, що він розташований поруч з готелем",
                "chooseAirportYouWantToArrive": "Виберіть аеропорт прибуття",
                "chooseAirportYouWantToArriveDescription": "Будь ласка, виберіть аеропорт, найближчий до готелю",
                "noFlightsForSelectedDatesLocationPassengers": "Немає доступних рейсів для вибраних дат/місця/пасажирів",
                "updateAirport": "Оновити аеропорт",
                "flightFrom": "Рейс з",
                "flightChange": "Зміна рейсу",
                "totalChange": "Загальна зміна",
                "noFlightsAvailableForSelectedDates": "Немає доступних рейсів на вибрані дати, будь ласка, виберіть інші дати",
                "show_tickets_with_different_fare_combinations":"Показати квитки з різними варіантами тарифів",
                "ticketFare":"Тариф",
                "ticketInfo":"Інформація про квиток",
                "termsAndConditions": "Правила та умови",
                "ifTicketIncludeSeat": "Якщо квиток включає місце - клієнту потрібно буде вибрати його на сайті авіакомпанії",
                "inCaseOfChange": "У разі зміни - клієнту потрібно буде доплатити, якщо оновлений квиток коштує дорожче, також стягується додаткова плата за сервіс згідно з Правилами та умовами сайту",
                "inCaseOfCancellation": "У разі скасування - буде додаткова плата за сервіс згідно з Правилами та умовами сайту",
                "error4305Title": "Ой, рейс повністю заброньований",
                "error4305Content": "Вибачте, але здається, що місця за цією пропозицією розпродані, і ми не можемо продовжити покупку. Ви будете перенаправлені на головну сторінку.",
                "TC": "ТК",
                "flights": "Рейси",
                "title": "Вибраний рейс, перевірте деталі та переходьте до оплати",
                "addBaggage": "Додати багаж",
                "closeAddBaggage": "Приховати опції",
                "addTrolly": "Додати тролей",
                "somethingWetWrong": "Щось пішло не так",
                "suitcasePrice": "Ціна валізи",
                "trollyPrice": "Ціна тролей",
                "totalPerPassenger": "Загальна сума на одного пасажира",
                "updatePassengers": "Оновити кількість пасажирів",
                "search": "Пошук",
                "seating": "Місця",
                "cancelation": "Скасування квитка",
                "meal": "Харчування",
                "trolly": "Тролей",
                "suitcase": "Валіза",
                "changeFlight": "Змінити квиток",
                "extension": "Продовження",
                "totalToBePaid": "Загальна сума до оплати",
                "choose": "Вибрати",
                "checkAmenities": "Перевірити зручності",
                "description": "Опис",
                "amenityType": "Тип зручностей",
                "flightFromAmenities": "Зручності під час польоту туди",
                "flightBackAmenities": "Зручності під час польоту назад",
                "BAGGAGE": "Багаж",
                "2 CHECKED BAGS UP TO 32KG EACH": "2 зареєстрованих багажі до 32 кг кожний",
                "2 CABIN BAGS UP TO 8KG": "2 ручні багажі до 8 кг",
                "BRANDED_FARES": "Брендові тарифи",
                "STANDARD SEAT RESERVATION": "Стандартне резервування місць",
                "MILEAGE_ACCRUAL": "Нарахування миль",
                "MEAL": "Харчування",
                "SNACK": "Закуска",
                "COMPLIMENTARY FOOD AND BEV": "Безкоштовна їжа та напої",
                "ENTERTAINMENT": "Розваги",
                "MAGAZINES / NEWSPAPER": "Журнали / Газети",
                "LOUNGE": "Зал очікування",
                "LOUNGE ACCESS": "Доступ до залу очікування",
                "TRAVEL_SERVICES": "Туристичні послуги",
                "PRIORITY BAGGAGE": "Пріоритетний багаж",
                "PRIORITY CHECK IN": "Пріоритетна реєстрація",
                "PRIORITY SECURITY": "Пріоритетний контроль безпеки",
                "PRIORITY BOARDING": "Пріоритетна посадка",
                "IN FLIGHT ENTERTAINMENT": "Розваги під час польоту",
                "PRE_RESERVED_SEAT": "Попередньо зарезервоване місце",
                "PRIVACY SEAT BUSINESS CLASS": "Приватне місце бізнес-класу",
                "CHANGE BEFORE DEPARTURE": "Зміна до вильоту",
                "CHANGE AFTER DEPARTURE": "Зміна після вильоту",
                "REFUND BEFORE DEPARTURE": "Повернення коштів до вильоту",
                "REFUND AFTER DEPARTURE": "Повернення коштів після вильоту"
            },
            "room": {
                "roomSize": "Розмір номера",
                "bedType": "Тип ліжка",
                "breakfastIncluded": "Сніданок включено",
                "noAvailabilityOnSelectedDates": "Немає вільних номерів на обрані дати"
            },
            "promotion": {
                "modelNotFound": "Сторінку не знайдено",
                "failToLoad": "Не вдалося завантажити сторінку!"
            },
            "attractions": {
                "showingMoreResults": "Показано більше результатів",
                "noMoreResults": "Більше результатів немає",
                "NoResultsMatchedTheFilterValues": "Немає результатів, що відповідають значенням фільтра",
                "inclusions": "включення",
                "exclusions": "Винятки",
                "overviewOfTheTrip": "Огляд поїздки",
                "immediateConfirmation": "Миттєве підтвердження",
                "pricePerPerson": "Ціна за людину",
                "totalForXXXPeople": "Загальна вартість для XXX осіб",
                "toOrder": "Замовити",
                "freeCancelation": "Безкоштовне скасування",
                "showAll": "Показати деталі",
                "hideAll": "Приховати деталі",
                "days": "дні",
                "rating": "рейтинг",
                "supplier": "постачальник",
                "location": "місцезнаходження",
                "pricePerPersonFrom": "Ціна за людину від",
                "selectDatesAndTravelers": "Виберіть дати та мандрівників",
                "bookNowWithFreeCancellation": "Забронюйте зараз з безкоштовним скасуванням",
                "updateSearch": "Оновити пошук",
                "activities-health-wellness-spas": "Спа",
                "activities-action-entertainment-shows-events": "Шоу та події",
                "activities-nature-outdoors-zoos-aquariums": "Зоопарки та акваріуми",
                "activities-food-drink": "Їжа та напої",
                "activities-action-entertainment-shopping": "Шопінг",
                "activities-nature-outdoors-tickets-passes": "Квитки та перепустки",
                "activities-action-entertainment-rentals-rides": "Оренда та поїздки",
                "activities-transportation": "Транспорт",
                "activities-culture-shows-events": "Шоу та події",
                "activities-nature-outdoors": "Природа та активний відпочинок",
                "activities-tours-by-theme-shopping-tours": "Шопінг тури",
                "activities-workshops-classes-sport-lessons": "Уроки спорту",
                "activities-action-entertainment-tickets-passes": "Квитки та перепустки",
                "activities-workshops-classes-music-dance": "Музика та танці",
                "activities-food-drink-workshops-classes": "Майстер-класи та уроки",
                "activities-health-wellness-relaxation": "Релаксація",
                "activities-tours-by-theme-food-drink-tours": "Тури по їжі та напоях",
                "activities-workshops-classes": "Майстер-класи та уроки",
                "activities-health-wellness-beauty-treatments": "Косметичні процедури",
                "activities-action-entertainment-water": "Вода",
                "activities-workshops-classes-arts-crafts": "Мистецтво та ремесла",
                "activities-tours-by-theme": "Тематичні тури",
                "activities-action-entertainment-land": "Сухопутні",
                "activities-tours-by-theme-sport-tours": "Спортивні тури",
                "activities-culture": "Культура",
                "activities-tours-by-theme-walking-tours": "Піші тури",
                "activities-health-wellness-alternative-medicine": "Альтернативна медицина",
                "activities-tours-by-theme-art-culture-tours": "Тури по мистецтву та культурі",
                "activities-workshops-classes-cultural-immersion": "Занурення в культуру",
                "activities-health-wellness": "Здоров'я та добробут",
                "activities-nature-outdoors-air-activities": "Повітряні активності",
                "activities-tours-by-theme-luxury-tours": "Розкішні тури",
                "activities-tours-by-theme-historical-heritage-tours": "Історичні тури",
                "activities-culture-art-culture-tours": "Тури по мистецтву та культурі",
                "activities-action-entertainment-air": "Повітря",
                "activities-tours-by-theme-nature-wildlife-tours": "Тури по дикій природі",
                "activities-tours-by-theme-discovery-tours": "Тури відкриттів",
                "activities-nature-outdoors-wildlife-nature-observation": "Спостереження за природою та дикою природою",
                "activities-action-entertainment": "Дія та розваги",
                "activities-tours-by-theme-museum-exhibition-tours": "Тури по музеях та виставках",
                "activities-workshops-classes-food-drink": "Їжа та напої",
                "activities-tours-by-theme-virtual-tours": "Віртуальні тури",
                "activities-tours-by-theme-special-tours": "Спеціальні тури",
                "activities-nature-outdoors-land-activities": "Сухопутні активності",
                "activities-transportation-rentals-rides": "Оренда та поїздки",
                "activities-nature-outdoors-water-activities": "Водні активності",
                "activities-food-drink-restaurants-bars": "Ресторани та бари",
                "activities-food-drink-food-drink-tours": "Тури по їжі та напоях",
                "activities-no-category": "Без категорії",
                "activities-health-wellness-retreats": "Ретріти",
                "activities-action-entertainment-sport-lessons": "Уроки спорту",
                "activities-tours-by-theme-self-guided-tours": "Самостійні тури",
                "activities-action-entertainment-multi-adventure-games": "Багатопригодницькі ігри",
                "activities-food-drink-tickets-passes": "Квитки та перепустки",
                "activities-tours-by-theme-night-tours": "Нічні тури",
                "activities-culture-tickets-passes": "Квитки та перепустки",
                "activities-transportation-transfers": "Трансфери",
                "hours": "Години",
            },
            "searchDatePicker": {
                "showingAllResultsWithin": "Показати всі результати в радіусі",
                'PARTICIPANTS': 'Учасники',
                'CITY': 'Місто',
                'COUNTRY': 'Країна',
                'EVENT_TYPE': 'Тип події',
                'TOURNAMENTS': 'Турніри',
                'VENUES': 'Місця проведення',
                "events":"Події",
                "sportsAndEvents":"Спорт та події",
                checking: "Перевірка",
                providers: "постачальників",
                keepScanning: "Продовжуйте сканувати",
                validatePricesInRealTime: "Перевірте ціни в реальному часі",
                foundSoFar: "Знайдено досі",
                return: "Повернення",
                calendar: "Календар",
                cubes: "Кубики",
                requiredFields: "Будь ласка, заповніть усі обов'язкові поля: пункт призначення, пункт відправлення та дати, щоб відобразити результати.",
                otherDeparture:"інший виїзд",
                departure: "Від'їзд",
                "mapView": "Перегляд карт",
                "freeCancellationTooltipText": "Безкоштовна відміна діє лише для номерів в отелі",
                "dynamicPackages": "Динамічні пакети",
                "includeEvents": "Включити події",
                "includeFullPackage": "Включити повний пакет",
                "searchHotelsByNameTitle": "Пошук за назвою готелю для вибраного напрямку",
                "choose_packages_according_to": "Виберіть пакети відповідно до",
                "package_hotel_flight": "Пакет (Отель + Рейс)",
                "package_hotel_flight_events": "Пакет (Отель + Рейс + Події)",
                "hotel_plus_flight": "Отель + Рейс",
                "hotel_plus_flight_events": "Отель + Рейс + Події",
                "tech_stops": "технічні зупинки",
                "freePlanFlightSearchFooterText": "Безкоштовний план дозволяє шукати лише чартерні рейси! Якщо ви хочете рейси GDS",
                "clickHere": "Натисніть тут",
                "approveSelection": "Approve Selection",
                "needAnotherRoomAddToCart": "Потрібен ще номер? Просто додайте до кошика.",
                "city": "City",
                "hotel": "Hotel",
                "searchByDestinationAndHotel": "Пошук за напрямками та готелями",
                "searchHotelOrDestination": "Пошук готелю або напрямку",
                "indirectFlight": "Непрямий політ",
                "directFlightLabel": "Прямий авіарейс",
                "date": "Date",
                "search": "Пошук",
                "rooms": "Номери",
                "composition": "Склад",
                "chooseComposition": "Виберіть склад",
                "numberOfGuests": "Кількість гостей",
                "checkOut": "Виїзд",
                "checkIn": "Заселення",
                "whatVacation": "Який вид відпустки",
                "youWant": "ви хочете",
                "vacationFriendsWith": "Відпустка з друзями",
                "familyVacation": "Сімейна відпустка",
                "romanticVacation": "Романтична відпустка",
                "notAvailable": "Недоступно",
                "roomAvailableDuringTheWeek": "Доступність номерів протягом тижня",
                "followingDates": "Наступні дати",
                "vacation": "Відпустка",
                "abroad": "За кордоном",
                "inIsrael": "В країні",
                "destination": "Усі напрямки",
                "chooseDestination": "Виберіть напрямки",
                "children": "Діти",
                "adults": "Дорослі",
                "findDreamVacation": "Знайдіть свою ідеальну відпустку одним кліком.",
                "searchResTitle": "Виберіть правильний пакет для вас",
                "checkHotel": "перевірити готель",
                "noRating": "Без рейтингу",
                "toOrder": "наказувати",

                "dynamicFlight": "Dynamic Flight",
                "bundle": "Bundled Flight",
                "freeCancelation": "Безкоштовне скасування",
                "partially_operated_by_airlines": "Partially operated by airlines",
                "connect_in_airport": "Connect in airport",
                "arrives": "Arrives",
                "journey_duration": "Journey Duration",
                "short_wait": "Short Wait",
                "long_wait": "Long Wait",
                "flight_number": "Flight Number",

            },
            "specialDeal": {
                "closeTheDeal": "Закрийте угоду ›",
                "endsIn": "Закінчується через",
                "specialDealForTheWeekend": "Спеціальна пропозиція на вихідні",
                "from": "З дати",
                "until": "До дати"
            },
            "footer": {
                "backToTop": "Повернутися до верху",
                "allRightsReserved": "© Усі права захищені. Не копіюйте вміст сайту без дозволу.",
                "developBy": "Розроблено SKY 360 Tech.",
                "thePurchaseOnTheWebsiteIsSecure": "Покупка на сайті є безпечною.",
                "talkToUs": "Як з нами спілкуватися?",
                "address": "Адреса",
                "phoneAndWhatsapp": "Телефон або WhatsApp",
                "phone": "Телефон",
                "whatsapp": "Whatsapp",
            },
            "sportsAndEvents": {
                "atLeastOneTicketMustBeSelected": "Необходимо выбрать хотя бы один билет",
                "dateNotFinal": "Дата не остаточна",
                "timeNotFinal": "Час не остаточний",
                "dateAndTimeNotFinal": "Дата та час не остаточні",
                "dateIsSubjectToChange": "Дата може бути змінена",
                "timeIsSubjectToChange": "Час може бути змінений",
                "dateAndTimeAreSubjectToChange": "Дата та час можуть бути змінені",
                "onlyAFewTicketsLeft": "Залишилось лише кілька квитків",
                "pricePerTicket": "Ціна за квиток",
                "totalPrice": "Загальна ціна",
                "cannotChangeSeatingFromThisPage": "Ви не можете змінити розсадку з цієї сторінки",
                "reselectSeating": "Перерозподілити місця",
                "sportsAndEvents": "Спорт та події",
                "noTitle": "Подія",
                "comingSoon": "Скоро!",
                "noTicketsAvailable": "Квитки недоступні",
                "selectTickets": "Виберіть квитки",
                "notifyMe": "Повідомити мене",
                "notifyMeDescription": "Введіть свою електронну адресу, щоб отримати сповіщення, коли квитки стануть доступними",
                "notifyMeEmailPlaceholder": "Введіть свою електронну адресу",
                "notifyMeSubmit": "Повідомити мене",
                "notifyMeSuccess": "Ви отримаєте сповіщення, коли квитки стануть доступними",
                "notifyMeError": "Не вдалося надіслати сповіщення. Будь ласка, спробуйте ще раз.",
                "notifyMeEmailRequired": "Будь ласка, введіть свою електронну адресу",
                "notifyMeEmailInvalid": "Будь ласка, введіть дійсну електронну адресу",
                "tournament": "Турнір",
                "participants": "Учасники",
                "eventType": "Тип події",
                "vipPackage": "VIP пакет",
                "hold24Hours": "Утримання 24 години",
                "instantConfirmation": "Миттєве підтвердження",
                "offlineStock": "Офлайн-наявність",
                "rating": "Рейтинг",
                "location": "Розташування",
                "dateTimeSeparator": " о ",
                "viewOnMap": "Показати на карті",
                "selectQuantity": "Виберіть кількість",
                "avenue": "Проспект",
                "venue": "Місце проведення",
                "city": "Місто",
                "country": "Країна",
                "state": "Штат",
                "zip": "Поштовий індекс",
                "latitude": "Широта",
                "longitude": "Довгота",
                "whereWillISit": "Де я сидітиму?",
                "seatingArrangements": "Схема розсадки",
                "seatingInPairs": "Розсадка парами",
                "seatingInPairsDescription": "Ми прагнемо розсадити вас парами (двоє разом), якщо категорія квитка не вказує інше.",
                "seatingInPairsNote": "ЗВЕРНІТЬ УВАГУ: на деяких стадіонах (зокрема, на \"Камп Ноу\" в Барселоні та \"Сантьяго Бернабеу\" в Мадриді) \"розсадка парами\" включає діагонально або перпендикулярно прилеглі місця.",
                "seatingThreeTogether": "Розсадка трьох і більше осіб",
                "seatingThreeTogetherDescription": "Коли вам потрібно три або більше квитків, ми зробимо все можливе, щоб розсадити вас разом; однак ми не можемо це гарантувати.",
                "seatingThreeTogetherNote": "Якщо вам НЕОБХІДНО сидіти разом, будь ласка, зв'яжіться з нашою службою підтримки клієнтів по телефону або електронною поштою. У більшості випадків ми зможемо підтвердити конкретний запит або запропонувати альтернативне рішення.",
                "homeFansOrAwayFans": "Фанати господарів чи гостей",
                "homeFansDescription": "Усі квитки для сектору господарів, якщо не вказано інше (\"Сектор гостей\").",
                "homeFansBehaviorCode": "Відповідно до правил поведінки організаторів, вам не дозволяється вболівати за команду гостей або носити кольори команди гостей. Учасникам також рекомендується носити одяг нейтральних кольорів, якщо вони не підтримують команду господарів. Недотримання цих правил може бути витлумачено як провокація і може призвести до вашого видалення зі стадіону.",
                "neutralVenueNote": "Вищевказані специфікації не застосовуються до матчів, які проводяться на нейтральному стадіоні (наприклад, фінал Ліги чемпіонів, фінал Ліги Європи, фінал Кубка Англії, фінал Кубка ліги або події Чемпіонату світу). Якщо не вказано інше, місця можуть знаходитися в будь-якому з секторів, тому рекомендується носити одяг нейтральних кольорів.",
                "singleTickets": "Одиночні квитки",
                "singleTicketsDescription": "Ми іноді пропонуємо квитки, які спеціально класифікуються як \"одиночні\".",
                "singleTicketsNote": "Ці квитки зазвичай дешевші, але вони є тим, чим вони є - одиночні. Якщо ви купите два \"Одиночні\" квитки, ви не будете сидіти разом.",
                "groupSeating": "Групова розсадка",
                "groupSeatingDescription": "Для 8 квитків або більше, будь ласка, перевірте наявність групової розсадки та ціну з нашою службою підтримки клієнтів по телефону або електронною поштою. Групова розсадка може коштувати менше або більше, залежно від наявності.",
                "groupSeatingNote": "Якщо обрана вами категорія квитків дозволяє це - ви можете оформити замовлення без попереднього контакту з нами, але пам'ятайте, у цьому випадку ми можемо гарантувати лише розсадку парами.",
                "pleaseNote": "Зверніть увагу",
                "pleaseNoteDescription": "Інформація вище про схему розсадки є загальною і в цілому може не відповідати точному опису обраного вами квитка. Коли доступно, ми представляємо відповідну схему розсадки або карту місця проведення.",
                "pleaseNoteConsult": "Будь ласка, ознайомтеся з нею при перегляді категорій квитків на цю подію.",
                "haveMoreQuestions": "Є ще питання?",
                "contactUsForInfo": "Для отримання додаткової інформації, будь ласка, зв'яжіться з нами",
                "eventLoadError": "Не вдалося завантажити деталі події",
                "quantity": "Кількість",
                "deliveryMethod": "Спосіб доставки",
                "selectDeliveryMethod": "Виберіть доставку",
                "ticketsAvailable": "квитків доступно",
                "available": "Доступно",
                "quantityCannotBeZero": "Кількість не може бути 0",
                "deliveryMethodNotFound": "Спосіб доставки не знайдено",
            },

            "newsletter": {
                "title": "Підпишіться на нашу розсилку",
                "subtitle": "Отримуйте ексклюзивні пропозиції та натхнення для подорожей",
                "placeholder": "Введіть ваш email",
                "subscribe": "Підписатися",
                "pleaseEnterEmail": "Будь ласка, введіть вашу електронну адресу",
                "somethingWentWrong": "Щось пішло не так. Спробуйте ще раз."
            },
            "packages": {
                "tour": "Тур",

                "from": "З дати",
                "until": "До дати",
                "breakfastIncluded": "Сніданок включено",
                "includesMassageAndSpa": "Включає масаж і SPA!",
                "lastRoom": "Останній номер!",
                "includesTransfers": "Включає трансфери",
                "includesActivities": "Включає визначні місця",
                "includesFlights": "Включає рейси",
                "includesEventTicket": "Включає квиток на подію",
                "nights": "Ночей",
                "withoutBaggage": "Без багажу",
                "directFlight": "Прямий рейс",
                "oneStop":"Один пересадочний пункт",
                "numOfStops":"Зупинки",
                "flightDetails": "Деталі політів",
                "flightFrom": " from -> to",
                "flightBack": " from -> to",
                "flightNumber": "Номер рейсу",
                "airLine": "Авіакомпанія",
                "suitcaseWeight": "weightкг Багаж включено",
                "trollyWeight": "weightкг Багажна тележка включена",
                "includedActivitiesTitle": "Атракції та екскурсії в пакеті",
                "checkAllPictures": "Переглянути всі фотографії",
                "affiliateWith": "У співпраці з",
                "addButtonDisabledTooltip": "Замовлення обмежено кількістю номерів - не можна додати інший номер. Щоб змінити номер, видаліть номер з кошика",
                "holidaySchedule": "Графік відпусток",
                "passengers":"Пасажири"
            },
            "roomPricing": {
                "noRoomsAvailableForSelectedDates": "Немає доступних номерів на вибрані дати, будь ласка, виберіть інші дати",
                "noRoomsAvailable": "Немає доступних номерів на вибрані дати та гостей.",
                "for": "для",
                "addPassenger": "Додати пасажира",
                "pricePerPerson": "Ціна за особу",
                "pricePerRoom": "Ціна за номер",
                "priceForAllRooms": "Ціна за всі кімнати",
                "payOnSpot": "Оплата на місці",
                "resort_fee": "Курортний збір",
                "occupancy_tax": "туристичний збір",
                "pricePerInfant": "Ціна за немовля",
                "composition": "Склад",
                "adultsInTheRoom": "Дорослі",
                "children": "Діти",
                "adults": "Дорослі",
                "single": "Один дорослий",
                "child": "Дитина",
                "selectInfantCount": "Виберіть зі списку",
                "infant": "Немовля",
                "1infant": "Одне немовля",
                "2infants": "2 немовля",
                "infants": "Немовлята",
                "noInfants": "Без немовлят",
                "all_include": "Все включено",
                "breakfast": "Сніданок",
                "activities": "Виберіть тур",
                "half_board": "Півпансіон",
                "half_board_kosher": "Кошерний півпансіон",
                "full_board": "Повний пансіон",
                "sleep_only": "Тільки сон",
                "breakfast_kidush": "П'ятниця ранок та вечірній обід",
                "addToCard": "Додати до замовлення",
                "inPackageDates": "В дати пакету",
                "chooseRoom": "Виберіть склад і номер",
                "nights": "Ночей",
                "boardType": "Тип харчування",
                "filters": "Фільтри",
                "freeCancellation": "Безкоштовна відміна",
                "roomInfo": "Інформація про номер",
                "noAvailableRooms": "На обрані дати немає доступних номерів",
                "noAvailableRoomsForDates": "Номер не доступний на обрані дати",
                "addInfant": "Додати немовля",
                "show_images": "Show Images",

                //// UPDATE IT LATERRR
                "roomFacilities": "Room Facilities",
                "until": "Until",
                "no": "No",
                "vat": "Vat",
                "is": "Is",
                "not": "Not",
                "city_tax": "City Tax",
                "cancellation_policy": "Cancellation Policy",
                "your_local_time": "*Your local Time",
                "additional_price_info": "Additional Price Info",
                "policy": {
                    "freeCancallationUntil": "Free cancellation at this rate until",
                    "freeCancallationUntil2": "ביטול חינם עד",
                    "cancallationBeCharged": "You will be charged",
                    "ifYouCancelBetween": "If you cancel from",
                    "ifYouCancelModifiedBetween": "If you cancelled or modified after",
                    "cancelFullPrice": "full price of the reservation will be charged",
                    "till": "till",
                    "rateNonRefundable": "The rate is non-refundable upon cancellation",
                }
            },
            "activitiesTranslations": {
                "addToOrder": "Додати до замовлення",
                "passenger": "Для пасажира",
                "showMore": "Показати більше",
                "addAttractionsAndTrips": "Додати атракції та екскурсії"
            },
            "modal": {
                "viewAllImages": "Переглянути всі зображення",
                "galleryTitle": "Галерея фотографій",
                "cancelationTerms": "Умови скасування - ",
                "nameOfTheHotel": "Деталі готелю",
                "hotelInfo": "Про готель",
                "hotelWebsite": "Посилання на веб-сайт готелю",
                "showMore": "Show More",
                "showLess": "Show Less",
            },
            "shoppingCartTranslations": {
                localInventoryAlert:"Замовлення зі спеціальним пакетом, наразі не підтримується для перегляду - лише для оплати",
                skyInventory:"Інвентар SKY",
                recommendedHotel:"Рекомендований готель",
                recommendedFlight:"Рекомендований рейс",
                "dynamicPackageTitleRemark": "Ціна включає рейс і готель - кожен продукт має свої умови і положення",
                "dynamicPackageTitleRemarkEvents": "Ціна включає рейс, готель і подію - кожен продукт має свої умови і положення",
                "productIsApproved": "Цей продукт було схвалено",
                "productIsNotApproved": "Цей продукт не було схвалено",
                "waitingToApprove": "Цей продукт обробляється",
                "productIsCancelled": "Цей продукт було скасовано",
                "orderIsApproved": "Це замовлення було схвалене!",
                "orderIsNotApproved": "Це замовлення не було схвалене!",
                "orderBeingProcessed": "Це замовлення обробляється",
                "orderIsCancelled": "Це замовлення було скасоване!",

                "attractionPriceDescription": "Ціна на атракціон залежить від дати, вибору опцій та кількості квитків",
                "selectedDate": "Выбранная дата",
                "selectADate": "Выберите дату",
                "availableDatesBetween": "Доступные даты между",
                "Options": "Опции",
                "Text": "Текст",
                "Ticket type": "Тип билета",
                "Start Time": "Время начала",
                'Guide language': "Мова довідника",
                "Pick Up Location": "Место отправления",
                "Custom Pick Up Location": "Пользовательское место отправления",
                "Drop Off Location": "Место прибытия",
                "Custom Drop Off Location": "Пользовательское место прибытия",

                'manageBaggage': "Управління багажем",
                "youCanAddGuestsOnlyUpToTheAvailableSeats": "Ви можете додати гостей лише до доступних місць",
                "paxExceedsAuthorizedSeats": "Кількість пасажирів перевищує кількість місць, дозволених за цим тарифом – зверніть увагу, що бронювання буде на запит, і ціна може змінитися",
                "paxExceedsAvailableSeats": "Кількість пасажирів перевищує доступну кількість місць – бронювання буде відправлено на затвердження постачальнику, і ціна може змінитися",

                "shoppingCartButtonTooltip": "Виберіть склад і додайте до замовлення",
                "totalPrice": "Загальна сума",
                "proceedToPayment": "Перейти до оплати",
                "placeOrder": "Перейти до реєстрації",
                "NoHotelWasChosenForTheVacation": "Готель не було обрано для відпустки",
                "betweenDates": "Між датами",
                "packageInformation": "Деталі пакета",
                "rooms": "Деталі номерів",
                "transfers": "Трансфери",
                "round_trip_transfers": "Трансфери/шатли до готелю в обидві сторони",
                "reg_transfers": "Трансфери/шатли до та з готелю",
                "shuttle_transfers": "Шатл з кордону до готелю і назад",
                "flights": "Рейси",
                "activities": "Атракції",
                "shoppingCart": "Кошик",
                "package": "Ночей в готелі",
                "nights": "Ночей",
                "inHotel": "В готелі",
                "apply": "Підтвердити",
                "promoCode": "Промокод",
                "yourShoppingCart": "Ваш кошик",
                "isEmpty": "Досі порожній...",
                "myVacation": "Моя відпустка",
                "showAll": "Показати все »",
                "beforeDiscount": "Загальна сума перед знижкою -",
                "agentCommission": "Агентська комісія -",
                "agentCommissionNet": "Агентська комісія (чистий платіж) -",
                "discountFromCode": "Знижка за кодом -",
                "affiliateWith": "У співпраці з -",
                "tpId": "ID замовлення -",
                "chargeTypeFullCC": "Повна оплата - включаючи комісію",
                "chargeTypeNetCC": "Оплата за чисту вартість",
                "chargeTypeCash": "Готівкова операція",
                "agentCommissionPrec": "Відсоток агентської комісії",
                "grossProfitPercentageInvalidRange": "Відсоток прибутку повинен бути від 0 до 99",
                "commissionMixedCurrencyTitle": "Як розрахована комісія",
                "commissionMixedCurrencyNote": "Комісія розподіляється між позиціями нижче та додається до кожної в її валюті, потім конвертується.",
                "commissionFlightLabel": "Рейс",
                "commissionRoomLabel": "Номер",
                "commissionTotalLabel": "Разом",
                "priceOff": "Знижка",
                "percentageOff": "Відсоток знижки",
                "selectedItems": "Вибрані товари",
                "viewProduct": "Переглянути товар",
                "attractionSearchFailed": "Не вдалося знайти атракцію",
                "searchOtherForDates": "Немає доступності, будь ласка, оберіть інші доступні дати",
                "cannotSearchForThePastDates": "Неможливо здійснити пошук за минулими датами",
                "eventTicketAlreadyAdded": "Неможливо додати однаковий тип билета, будь ласка, оберіть інший тип билета",
                'failedToAddEventTicket':"Не вдалося додати билет события",
                "eventTicketPaxMismatchTitle": "Кількість білетів і пасажирів не збігається",
                "eventTicketPaxMismatch": "Кількість обраних білетів на подію не збігається з кількістю пасажирів (рейс/номер). Оновіть кількість білетів або вибір номера.",
                "attractionAlreadyAdded": "Неможливо додати однаковий тип атракції, будь ласка, оберіть інший тип атракції",
                "failedToAddAttraction": "Не вдалося додати атракцію",
                "noAvailabilityOnThisDates": "Немає доступності на вибрані дати",
                "unableToAddRoomToSamePackage": "Неможливо додати номер в той же пакет",
                "roomApprovalIsSubjectToRoomAvailability": "Одобрення номера залежить від наявності номера",
                "roomsByRequestSubjectOfHotelAvailability": "Неможливо додати той самий тип номера, будь ласка, оберіть інший тип номера",
                "roomsByRequestSubjectOfHotelAvailabilityTitle": "Не вдалося додати номер",
                "youReachedMaxRooms": "Ви досягли максимальної кількості номерів",
                "createOrderError": "Не вдалося зберегти пропозицію, спробуйте ще раз",
                "avgPricePerPerson": "Додати середню ціну на особу",
                "avgPricePerPersonLine": "Середня ціна на особу",
                "totalPaxLabel": "Кількість пасажирів",
                "copyQuoteTakanonLine": "Будь ласка, переконайтеся, що ви прочитали та погодилися з умовами перед покупкою\nПосилання на умови угоди: {domain}/takanon",
                "copyWithOrgDays": "Скопіювати пропозицію з розкладом днів",
                "orgItineraryHeader": "Маршрут по днях",
                "orgTourPackageLine": "Організований тур до {destination}, Назва туру: {tourName}, {nights}, {dateStart} - {dateEnd}",
                "packageToDestinationLine": "Відпускний пакет до {destination}",
            },
            "checkout": {
                "cityOfBirth": "Місто народження",
                "nationalityCountryId": "Країна громадянства",
                "fill_out_at_least_one_guest_fields": "Будь ласка, заповніть усі поля хоча б для одного гостя!",
                "addRestOfGuests": "Додати решту гостей",
                "hideRestOfGuests": "Hide Rest Of Guests",
                "addBaggage": "Додати багаж",
                "newGuest": "Новий гість",
                "selectGuest":"Вибрати гостя",
                "chooseExistingGuest": "Використати існуючого гостя",
                "additionalBaggage": "Додатковий багаж",
                "free": "безкоштовно",
                "room": "Номер",
                "personalInfo": "Дані відпочиваючих",
                "paymentDetails": "Деталі платежу",
                "orderCompletion": "Завершення замовлення",
                "userDetails": "Деталі замовника",
                "name": "Ім'я",
                "lastName": "Прізвище",
                "passport": "Паспорт",
                "inEnglish": "",
                "birthdate": "Дата народження",
                "phone": "Телефон",
                "email": "Електронна пошта",
                "notesForTheOrder": "Примітки до замовлення",
                "namesOfGuests": "Імена пасажирів",
                "namesMustMatchPassport": "* Усі імена повинні бути введені англійською мовою точно так, як вони вказані в паспорті",
                "goToPayments": "Підтвердити та перейти до оплати",
                "saveAndCommit": "Зберегти і підтвердити пропозицію",
                "saveAndPayLater": "Зберегти і оплатити пізніше",
                "saveOrder": "Зберегти замовлення",
                "agreement": "Я підтверджую умови веб-сайту, умови замовлення та умови скасування замовлення",
                "men": "Чоловік",
                "women": "Жінка",
                "pleaseInputYourPhone": "Будь ласка, введіть номер телефону",
                "pleaseInputYourLastName": "Будь ласка, введіть ваше прізвище",
                "pleaseInputYourFirstName": "Будь ласка, введіть ваше ім'я",
                "pleaseInputYourEmail": "Будь ласка, введіть вашу електронну пошту",
                "pleaseInputYourPassportNumber": "Будь ласка, введіть номер вашого паспорта",
                "pleaseInputYourDateOfBirth": "Будь ласка, введіть вашу дату народження",
                "pleaseSelectGender": "Будь ласка, виберіть стать",
                "maxChildAge": "Дитина віком від 2 років -",
                "maxInfantAge": "Немовля повинно бути менше двох років на момент відпустки",
                "pleaseAgreeWithT&C": "Будь ласка, погодьтеся з умовами використання та правилами веб-сайту",
                "viewTerms": "Переглянути правила",
                "invalidEmail": "Недійсна електронна пошта",
                "orderCreateSuccess": "Ваше замовлення успішно збережено, вас перенаправляють до оплати",
                "orderCreateFree": "Ваше замовлення успішно збережено!",
                "orderUpdateSuccess": "Ваше замовлення успішно оновлено!",
                "mainRoomGuestTitle": "Номер на ім'я",
                "uploadPassportImage": "Завантажити фотографію паспорта",
                "addInfant": "Додати немовля",
                "updateInfant": "Оновити кількість немовлят",
                "howManyInfantsDoYouWantToAdd": "Виберіть кількість немовлят для цього номера",
                "add": "Додати",
                "setInfantCountForRoom": "Оновити кількість немовлят",
                "setInfantCountForRoomSuccess": "Кількість немовлят успішно оновлено",
                "infantsAddedToTheRoom": "Немовлята додані до номера",
                "selectNumberOfInfants": "Виберіть кількість немовлят",
                "pricePerInfant": "Ціна за немовля",
                "infantsRemoved": "Немовлята були видалені з цього номера",
                "requiredUploadPassportImage": "Завантаження фотографії паспорта обов'язкове",
                "infantError4403": "Неможливо змінити кількість немовлят - будь ласка, зв'яжіться з центром обслуговування",
                "docketId": "* ID документа",
                "agencyId": "* ID агентства",
                "documentType": "Тип документа",
                "documentTypeInfo": "Оберіть ID картку для внутрішніх рейсів",
                "documentTypePassport": "Паспорт",
                "documentTypeIdCard": "ID картка",
                "issuingCountry": "Країна видачі",
                "residenceCountry": "Країна проживання",
                "nationality": "Національність",
                "documentNumber": "Номер документа",
                "documentNumberPassport": "Номер паспорта",
                "documentNumberIdCard": "Номер ID картки",
                "pleaseInputPassportNumber": "Будь ласка, введіть номер паспорта",
                "pleaseInputIdCardNumber": "Будь ласка, введіть номер ID картки",
                "expirationDate": "Дата закінчення",
                "pleaseSelectDocumentType": "Будь ласка, оберіть тип документа",
                "pleaseSelectIssuingCountry": "Будь ласка, оберіть країну видачі",
                "pleaseSelectResidenceCountry": "Будь ласка, оберіть країну проживання",
                "pleaseSelectNationality": "Будь ласка, оберіть національність",
                "pleaseInputDocumentNumber": "Будь ласка, введіть номер документа",
                "pleaseSelectExpirationDate": "Будь ласка, оберіть дату закінчення"
            },
            "manageOrder": {
                moveToPaymentWarning: 'Інформацію про клієнта не збережено, а інформація про гостей порожня! Ви впевнені, що хочете продовжити?',
                moveToPaymentWarning1: 'Інформацію про клієнта не збережено. Ви впевнені, що хочете продовжити?',
                moveToPaymentWarning2: 'Інформація про гостей порожня! Ви впевнені, що хочете перейти до оплати?',
                "moveToPayment": "Додати спосіб оплати",
                "backToManage": "Повернутися до управління замовленням",
                "paymentTitle": "Додати спосіб оплати",
                "manageTitle": "Оновлення даних відпочиваючих",
                "modelNotFound": "Замовлення не знайдено",
                "failToLoad": "Не вдалося завантажити дані замовлення, будь ласка, спробуйте пізніше.",
                "orderId": "Управління замовленням",

                "room_booking_cancelled_successfully": "Бронювання номера успішно скасовано",
                "room_booking_cancel_error": "Помилка під час скасування бронювання номера",
                "cancel_room_booking_warning": "Скасовуючи номер, ви втратите бронювання та ціну. Ви впевнені?",
                "cancel_booking": "Скасувати бронювання",
                "incompleteDPsWereRemoved": 'Неповні динамічні пакети були видалені з вашого кошика. Будь ласка, додайте їх знову з готелем+рейсом і квитками на події.',

            },
            "completionForm": {
                "paymentFinish": {
                    "title": "Замовлення успішно зроблене - оплата завершена",
                    "info": "На вашу адресу відправлено електронний лист із деталями замовлення"
                },
                "waitingToApprove": {
                    "title": "Ваше замовлення надіслано на схвалення",
                    "info1": "Деталі замовлення збережено в системі та надіслано на схвалення.",
                    "info2": "Оплата буде здійснена лише після схвалення замовлення.",
                    "info3": "Після схвалення замовлення вас повідомлять електронною поштою про підтвердження та оплату."
                },
                "paymentFail": {
                    "title": "Оплата не вдалася",
                    "info1": "Оплата не вдалася :(",
                    "infoFail": "Після декількох спроб оплати вона не вдалася - спробуйте ще раз",
                    "infoWhatsapp": "Якщо виникла помилка та ви не можете оплатити, зв'яжіться через WhatsApp за адресою: "
                },
                "orderNum": "Номер замовлення",
                "thanksForChoose": "Дякуємо за вибір",
                "free": {
                    "title": "Реєстрація пройшла успішно",
                    "info": "На вашу адресу відправлено електронний лист із підсумками замовлення"
                },
                "pay_later": {
                    "title": "Реєстрація пройшла успішно",
                    "info": "На вашу адресу відправлено електронний лист із підтвердженням замовлення"
                }
            },
            "paymentForm": {
                "card": "Кредитна карта",
                "creditCardInterest": "Процент кредитної картки",
                "interest": "відсоток",
                "creditNotSaveInBd": "Дані кредитної картки не зберігаються на сайті - ви робите безпечний платіж",
                "title": "Введіть спосіб оплати (лише Visa і Mastercard)",
                "splitBtn": "Клацніть, щоб розділити кредитні карти",
                "splitTitle": "Розділити кредитні карти",
                "splitDesc": "Виберіть кількість кредитних карток для розділення та клацніть «Підтвердити»",
                "noSplit": "Без поділу",
                "noPayments": "Без оплати",
                "payments": "Оплати",
                "paymentsNum": "Кількість платежів",
                "withDebit": "З кредитом",
                "splitBy": "Кредитні карти",
                "toPay": "До оплати",
                "splitApprove": "Підтвердити",
                "currencyRate": "Сплата здійснюється в шекелях - за туристичним курсом",
                "splitCurrentCardNum": "Розділити кредит",
                "splitCurrentCardNumFrom": "З",
                "errorMessageToRetry": "Спроба № {retryNum} - не вдалося здійснити платіж від компанії, що видає кредитну картку. Введіть дані картки ще раз або іншу картку. Веб-сайт приймає лише картки VISA та MASTERCARD.",
                "installments": "Розстрочка",
                "installmentsLabel": "Кількість платежів",
                "installmentFee": "Комісія за розстрочку",
                "totalToPay": "Всього до сплати",
                "perMonth": "на місяць",
                "installmentsDisclosure": "Розстрочка обробляється емітентом вашої картки. Загальна сума включає комісію за розстрочку.",
            },
            "hotelTypes": {
                "Hotel": "Hotel",
            },
            "hotelDetails": {
                "updateDates": "Оновити дати",
                "roomTypesToChooseFrom": "Виберіть типи номерів",

                "metapolicy": "מדיניות המלון",
                "metaExtraInfo": "פרטים נוספים",
                "not_included": "לא כלול",
                "included": "כלול",
                "price": "בעלות של",
                "address": "כתובת",
                "other": "כתובת",
                "Location": "מיקום מלון",
                "At the boutique hotel ": "על המלון",
                "Room amenities": "שירות חדרים",

                "parking": "חניה",
                "pets": "חיות מחמד",
                "shuttle": "הסעה לשדה (לכיוון)",
                "internet": "שירותי אינטרנט",
                "extra_bed": "מיטה נוספת",
                "add_fee": "תוספת תשלום",
                "children_meal": "ארוחת ילדים",
                "check_in_check_out": "צ׳ק אין וצ׳ק אווט",

            },
            "sideFilters": {
                "sortBy": "Сортувати за",
                "price_asc": "Самая низкая цена",
                "price_desc": "Самая высокая цена",
                "hotel_stars_asc": "Самая низкая оценка отеля",
                "hotel_stars_desc": "Самая высокая оценка отеля",
                "distance": "Дистанция",
                "distance_asc": "Самая близкая дистанция",
                "distance_desc": "Самая дальняя дистанция",
                "recommended": "Рекомендовано",
                "price": "Ціна",
                "clearSideFilters": "Очистити фільтри",
                "ts_type": "Типи рейсів",
                "auto_approve": "Миттєве підтвердження",
                "include_transfer": "Включити трансфер",
                "include_baggage": "Включити багаж",
                "include_trolly": "Включити візок",
                "auto_approve_checked": "Показувати результати з миттєвим підтвердженням",
                "from_date_hours": "Час вильоту",
                "isSpecial": "Спеціальний",
                "is_special": "Спеціальний",
                "date_range": "Диапазон дат",
                "from_date_landing_hours": "Час вильоту",
                "flight_stop_time": "Час зупинки",
                "return_date_landing_hours": "Час повернення",
                "return_date_hours": "Час повернення",
                "airline": "Авіакомпанія",
                "2": "Чартерні рейси",
                "3": "Регулярні рейси",
                "nonStop": "Без пересадок",
                "stop": "Одна пересадка",
                "stops_plural": "Пересадки",
                "hotel_type": "Типи проживання",
                "stops": "Кількість пересадок",
                "freeCancellation": "Безкоштовне скасування?",
                "freeCancellationLabels": {
                    "1": "Тільки з безкоштовним скасуванням",
                    "0": "Без безкоштовного скасування"
                },

                "feature": "Особливість",

                "event_type": "Типи подій",
                "avenue": "Проспект",
                "event_date": "Дата події",
            },
            "package_feature": {
                "SPECIAL PACKAGE": "Спеціальний пакет",
                "ALL PACKAGES": "Усі пакети",
                "KOSHER": "Кошерний",
                "TOUR": "Тур",
                "SKI": "Лижі",
                "EVENT": "Подія",
                "SPORT": "Спорт",
                "SPA": "Спа",
                "YOUNG VACATION": "Молодіжний відпочинок",
                "FLT+HTL+CAR": "Політ+Готель+Авто"
            },
            "hotelAmenities": {
                // "dummy": "dummy"
            },
            "general": {
                "km": "км",
                "showingAllResultsWithin": "Показати всі результати в радіусі",
                "kmFromVenue": "км від місця",
                "kmFromCityCenter": "км від центру міста",
                openBO: "Відкрити бек-офіс",
                logOut: "Вийти",
                "toOrder": "Замовити",
                "amount": "Сума",
                parentOriginal: "Оригінал від батьківського сайту",
                parentEdited: "Відредаговано з батьківського сайту",
                "fetchingMoreResults": "Завантаження додаткових результатів...",
                "error": "Помилка",
                "somethingWentWrong": "Щось пішло не так. Спробуйте ще раз.",
                "noResultsFound": "Подій не знайдено",
                "tryAdjustingFilters": "Спробуйте змінити фільтри або критерії пошуку",
                "refresh": "Оновити",
                "list": "Список",
                "matched": "Співпадає",
                "sameRates": "Однакові тарифи",
                "rates": "Ціни",
                "calculatedRates": "Розраховані ціни",
                "to": "до",
                "roomOnly": "Лише номер",
                "totalPrice": "Загальна ціна",
                "flight": "Рейс",
                "close": "Закрити",
                "language": "Мова",
                "remark": "Примітка",
                "addService": "Додати послугу",

                packagesMainTitle: "Турпакети",
                vacationAtHeader: "Відпустка при",
                daysOfStay:'Дні перебування',
                lowPrice: "Низька ціна",
                flightUpTo: "Переліт від",
                flightsPromoTitle: "останні польоти",
                additionalFlights:"Додаткові рейси",
                "additionalPackages": "Додаткові пакети",
                "packagePlan": "Путівки від",
                "immediateApproval": "Негайне схвалення",
                "total": "Разом",
                "as_of_today": "станом на сьогодні",
                "priceInIls": "({price} ₪)",
                "link_to_the_offer": "Посилання на пропозицію",
                "the_quote_has_been_copied_successfully": "Цитата успішно скопійована",
                "base": "Основа",
                "submit": "Submit",
                "maxAmountOf": "Максимальна кількість",
                "minAmountOf": "Мінімальна сума",
                "ticketType": "Тип квитка",
                "cancellation_policy": "Політика скасування",
                "additionalInfo": "Додаткова інформація",
                "hour": "година",
                "minute": "хвилина",
                "before": "раніше",
                "date": "Дата",
                "duration": "Тривалість",
                "quantity": "Кількість",
                "tickets": "Квитки",
                "deliveryMethod": "Спосіб доставки",
                "for":"для",
                "free": "безкоштовно",
                "freeOfCharge": "Безкоштовно",
                'option': 'Варіант',
                'removeSelection': 'Зняти виділення',
                'grandTotalPrice': 'Загальна ціна',
                'startingPrice': 'стартова ціна',
                "usd": "USD",
                "euro": "EURO",
                "address": "Адреса",
                "type": "Тип",
                "noResults": "Немає результатів",
                "nights": "Ночей",
                "includesActivities": "{NUMBER} подарункових атракцій!",
                "includesActivity": "Включає подарунковий атракціон!",
                "adults": "Дорослі",
                "all_include": "Все включено",
                "breakfast": "Сніданок",
                "half_board": "Півпансіон",
                "half_board_kosher": "Кошерний півпансіон",
                "full_board": "Повний пансіон",
                "sleep_only": "Тільки проживання",
                "breakfast_kidush": "П'ятниця сніданок та обід",
                "addToCard": "Додати до замовлення",
                "chooseRoom": "Виберіть склад і номер",
                "boardType": "Тип розміщення",
                "filters": "Фільтри",
                "rating": "Рейтинг готелю",
                "event": "Подія",
                "attraction_stars": "Рейтинг атракції",
                "name": "Назва",
                "taxonomies": "Таксономії",
                "children": "Діти",
                "toDate": "До",
                "transfers": "Трансфери",
                "from": "Починаючи з",
                "totalRoomPrice": "Загальна сума",
                "perPerson": "За особу",
                "perPax": "за одиницю",
                "include": "Включає",
                "noIncludeText": "Пакети відпусток",
                "flights": "Рейси",
                "vacationAt": "Відпустка в {DEST}",
                "fieldRequired": "Обов'язкове поле",

                "h": "h",
                "min": "min",

                "loading": "Завантаження",
                "showingMoreResults": "Показ додаткових результатів",
                "noMoreResults": "Більше результатів немає",
                "NoResultsMatchedTheFilterValues": "Немає результатів, що відповідають параметрам фільтру",
                "eventTicketsAdded": "Квитки на подію додано",
                "addEventTickets": "Додати квитки на подію",
                "add": "Додати",
            },
            "subsidizedForm": {
                "title": "Додати субсидію",
                "employee_id": "Номер співробітника",
                "person_id": "Ідентифікаційний номер (9 цифр)",
                "validate": "Перевірити код співробітника",
                "alreadyApplied": "Субсидію вже застосовано",
                "addOneMore": "Додати ще одну субсидію",
                "addOneMoreId": "Додати іншого співробітника",
                "fieldRequired": "Обов'язкове поле",
                "priceReducedBy": "Ціна знижена на",
                "forEmployee": "Для співробітника",
                "employeeIs": "Успішно ідентифікований",
                "error4401": "Не вдалося ідентифікувати, спробуйте ще раз",
                "error4402": "Код ідентифіковано, але вже використовується",
                "guestIdentifiedId": "Ідентифікований за ідентифікаційним номером",
                "guestNotIdentified": "Ви повинні ідентифікуватися перед реєстрацією",
                "clickToIdentify": "Клацніть, щоб ідентифікувати"
            },
            "uploadImage": {
                "uploadPassportImage": "Завантажити фото паспорта",
                "somethingWentWrong": "Щось пішло не так"
            },
            "flightButton":{
                "no_availability_for_this_flight_price": "Вибачте, але більше немає доступності за цією ціною на переліт",
                "continueToOrder":"מעבר להזמנה",
                "addToCart":"הוסף לסל",
                "lastPlace":"מקומות אחרונים",
                "pricePerPassenger":"מחיר לנוסע",
                "cardConditions": "Умови картки",
            },
            "agentCommission":{
                'supplier':"ספק",
                'commission':"עמלה",
                "recommendedFee":"עמלה",
                "transactionDetailsForAgent":"פרטי עסקה לסוכן",
                "supplierNotes":"הערות ספק",
                "cancellationConditions":"ותנאי ביטול",
                "addToCartToChangeFree":"הוסף לסל לשינוי עמלה",
                "pricesShownAreNetPrices":"המחירים המוצגים הינם מחירי נטו",
                "packageRemarks": "package remarks",
            },
            "onboarding": {
                "openOnboarding": "Посібник",
                "welcomeTitle": "Ласкаво просимо до Sky360",
                "subtitle": "Отримайте максимум від нашої платформи за допомогою цього короткого туру. Виконайте кожен крок, щоб дізнатися про все, що ми пропонуємо.",
                "progressTitle": "Ваш прогрес",
                "progressLabel": "Виконано",
                "continueOnboarding": "Продовжити",
                "yourPath": "Кроки навчання",
                "pathSubtitle": "Дотримуйтесь цих кроків, щоб вивчити всі наші продукти.",
                "markAsDone": "Позначити як виконане",
                "upNext": "НАСТУПНЕ",
                "continue": "Продовжити",
                "outcomesTitle": "ЩО ВИ ДІЗНАЄТЕСЬ",
                "outcome1": "Пошук і бронювання",
                "outcome1Desc": "Знайдіть пакети, рейси, готелі та багато іншого.",
                "outcome2": "Заходи та визначні місця",
                "outcome2Desc": "Відкрийте місцеві враження у вашому напрямку.",
                "stepCompleted": "Виконано",
                "stepCompletedBanner": "Крок виконано! Ви чудово прогресуєте.",
                "stepCompletionTitle": "Крок {num} виконано!",
                "stepCompletionKicker": "Чудова робота — продовжуйте!",
                "tasksCompleted": "Завдання: {done}/{total} виконано",
                "typeTask": "ЗРОБИТИ",
                "stepLabel": "КРОК",
                "nextStepHint": "Наступний: Крок {num} — {title}",
                "continueUpNext": "Почати",
                "tourFinishBtn": "Готово",
                "tourNextBtn": "Далі",
                "tourPrevBtn": "Назад",
                "tourActionHint": "👆 Натисніть кнопку вище, щоб продовжити",
                "typeLearn": "ВЧИТИСЬ",
                "steps": {
                    "step1": { "title": "Пошук туристичних пакетів", "description": "Дізнайтеся, як знайти та забронювати пакети з перельотами і готелями." },
                    "step2": { "title": "Пошук рейсів", "description": "Знайдіть рейси в один бік або туди-назад, налаштуйте пасажирів і дати." },
                    "step3": { "title": "Пошук готелів", "description": "Переглядайте готелі за напрямком, датами заїзду і кількістю гостей." },
                    "step4": { "title": "Визначні місця", "description": "Відкрийте місцеві заходи та туристичні пам'ятки у вашому напрямку." },
                    "step5": { "title": "Пошук заходів", "description": "Переглядайте майбутні заходи та поєднуйте їх з рейсом і готелем." },
                    "step6": { "title": "Огляд пошукової системи", "description": "Перемикайтеся між усіма типами продуктів в одному місці." },
                    "step7": { "title": "Пошук динамічних пакетів", "description": "Дізнайтеся, як створити індивідуальну подорож, обравши напрямок або готель і додавши прямий рейс." },
                    "step8": { "title": "Створення бронювання рейсу", "description": "Пройдіть повний процес бронювання рейсу — від пошуку до оплати." },
                    "step9": { "title": "Огляд панелі агента", "description": "Панель агента у верхній частині B2C дозволяє керувати клієнтами, перемикати режими ціноутворення, переглядати баланс Diamonds та багато іншого." },
                    "step10": { "title": "Створення бронювання пакету", "description": "Пройдіть повний процес бронювання пакету — від пошуку до оплати." },
                    "step11": { "title": "Огляд сторінки керування замовленням", "description": "Ознайомтесь зі сторінкою керування замовленням — переглядайте деталі бронювання, оновлюйте дані гостей і переходьте до розділу оплати." }
                },
                "tour": {
                    "seModHoverTitle": "Дослідіть дії модуля",
                    "seModHoverDesc": "Наведіть курсор на будь-який модуль на сторінці нижче — з'явиться невелика панель дій для цього модуля. Наведіть на один зараз, щоб переглянути, що робить кожна дія.",
                    "seModAddTopTitle": "Додати модуль зверху",
                    "seModAddTopDesc": "Вставляє абсолютно новий модуль безпосередньо над цим. Натисніть, щоб обрати тип модуля та розмістити його.",
                    "seModReorderTitle": "Змінити порядок модуля",
                    "seModReorderDesc": "Використовуйте стрілки вгору та вниз, щоб перемістити модуль раніше або пізніше на сторінці. Попередній перегляд оновлюється миттєво.",
                    "seModEditTitle": "Редагувати модуль",
                    "seModEditDesc": "Відкриває цей модуль на панелі налаштувань ліворуч, де ви можете змінити його вміст, макет і стиль.",
                    "seModDeleteTitle": "Видалити модуль",
                    "seModDeleteDesc": "Видаляє цей модуль зі сторінки. Ви завжди можете додати його знову пізніше через опції додавання модуля.",
                    "seModAddBottomTitle": "Додати модуль знизу",
                    "seModAddBottomDesc": "Вставляє абсолютно новий модуль безпосередньо під цим — те саме, що верхня кнопка, лише для слота знизу.",
                    "packagesDpSwitchTitle": "Динамічні пакети — рейс + готель", "packagesDpSwitchDesc": "Перейдіть у режим динамічного пакету — оберіть готель і система поєднає його з найдешевшим доступним рейсом за маршрутом, створюючи конкурентну повну ціну пакету на місці.",
                    "packagesFeaturesTitle": "Категорії пакетів", "packagesFeaturesDesc": "Виберіть тип туристичного пакету — організовані тури, спортивні поїздки, кошерні тури та інше.",
                    "pkgSpecialTitle": "Спеціальні пакети — фіксована комісія 10%", "pkgSpecialDesc": "Це категорія спеціальних пакетів — організовані групові тури, якими керує платформа. Кожен спеціальний пакет містить фіксовану агентську комісію 10%. Чудово для швидкого впевненого продажу — без переговорів про ціну.",
                    "pkgOtherCatsTitle": "Інші категорії пакетів", "pkgOtherCatsDesc": "Це інші категорії пакетів — організовані тури, кошерні подорожі, гірськолижні тури, спа-відпочинок, спортивні заходи та інше. Кожна категорія автоматично фільтрує доступні пакети та напрямки.",
                    "pkgSelectCatTitle": "Спробуйте — оберіть категорію", "pkgSelectCatDesc": "Натисніть на будь-яку картку категорії, щоб відфільтрувати пакети за типом. Список доступних напрямків оновиться автоматично.",
                    "pkgFilteredDestsTitle": "Відфільтровані напрямки", "pkgFilteredDestsDesc": "При виборі категорії список напрямків автоматично фільтрується, щоб показати лише місця, де доступні пакети цього типу. Оберіть напрямок для продовження.",
                    "pkgDeselectCatTitle": "Натисніть ще раз для скасування", "pkgDeselectCatDesc": "Повторне натискання на активну категорію скасує її — список напрямків повернеться до всіх доступних пакетів. Спробуйте зараз.",
                    "pkgDepartureTitle": "Місто відправлення", "pkgDepartureDesc": "Оберіть аеропорт або місто, з якого ви будете летіти у рамках пакетного туру.",
                    "packagesDestTitle": "Вибрати напрямок", "packagesDestDesc": "Виберіть один або кілька напрямків для вашого пакету.",
                    "packagesGuestsTitle": "Пасажири", "packagesGuestsDesc": "Виберіть кількість пасажирів — дорослих, дітей і немовлят — для вашого туристичного пакету.",
                    "packagesDatesTitle": "Дати подорожі", "packagesDatesDesc": "Виберіть дати відправлення і повернення для пакету.",
                    "packagesSearchTitle": "Знайти пакети", "packagesSearchDesc": "Натисніть тут, щоб знайти доступні пакети.",
                    "flightTripTypeTitle": "Тип поїздки", "flightTripTypeDesc": "Перемикайтеся між рейсом в один бік і туди-назад.",
                    "flightDirectTitle": "Тільки прямі рейси", "flightDirectDesc": "Увімкніть цей перемикач для фільтрації результатів — лише прямі рейси без пересадок.",
                    "flightDepartureTitle": "Місто вильоту", "flightDepartureDesc": "Виберіть аеропорт або місто вильоту.",
                    "flightArrivalTitle": "Призначення", "flightArrivalDesc": "Виберіть аеропорт або місто призначення.",
                    "flightPaxTitle": "Пасажири", "flightPaxDesc": "Задайте кількість дорослих, дітей і немовлят.",
                    "flightDatesTitle": "Дати рейсу", "flightDatesDesc": "Виберіть дату вильоту і дату повернення для рейсів туди-назад.",
                    "flightSearchTitle": "Знайти рейси", "flightSearchDesc": "Натисніть для пошуку доступних рейсів.",
                    "hotelDestTitle": "Напрямок готелю", "hotelDestDesc": "Знайдіть місто або регіон для проживання.",
                    "hotelGuestsTitle": "Номери і гості", "hotelGuestsDesc": "Додавайте скільки завгодно кімнат і налаштовуйте кожну окремо — вкажіть кількість дорослих, дітей та немовлят для кожної кімнати. Поєднуйте різні конфігурації відповідно до складу будь-якої групи: пари, сім'ї або будь-яка комбінація.",
                    "hotelDatesTitle": "Заїзд і виїзд", "hotelDatesDesc": "Виберіть дати заїзду і виїзду.",
                    "hotelSearchTitle": "Знайти готелі", "hotelSearchDesc": "Натисніть для пошуку доступних готелів.",
                    "attrDestTitle": "Місто атракції", "attrDestDesc": "Введіть або виберіть місто для пошуку визначних місць.",
                    "attrDatesTitle": "Дати активності", "attrDatesDesc": "Виберіть діапазон дат для заходів.",
                    "attrTypeTitle": "Тип атракції", "attrTypeDesc": "Фільтрація за категорією — музеї, активний відпочинок, екскурсії тощо.",
                    "attrSearchTitle": "Знайти визначні місця", "attrSearchDesc": "Натисніть для пошуку доступних атракцій.",
                    "eventsPackageTitle": "Включити повний пакет", "eventsPackageDesc": "Увімкніть цей перемикач, щоб поєднати захід з рейсом і готелем.",
                    "eventsEventTitle": "Знайти захід", "eventsEventDesc": "Введіть назву заходу або перегляньте доступні варіанти.",
                    "eventsDatesTitle": "Дати заходу", "eventsDatesDesc": "Виберіть діапазон дат заходу, який ви хочете відвідати.",
                    "eventsSearchTitle": "Знайти заходи", "eventsSearchDesc": "Натисніть для пошуку доступних заходів.",
                    "mainTabsTitle": "Вибрати тип пошуку", "mainTabsDesc": "Перемикайтеся між пакетами, рейсами, готелями, визначними місцями та заходами.",
                    "mainFormTitle": "Форма пошуку", "mainFormDesc": "Заповніть дані про подорож і натисніть «Знайти».",
                    "mainPkgTabTitle": "Тури", "mainPkgTabDesc": "Знайдіть туристичні пакети «все включено» з авіаквитками та готелями. Натисніть цю вкладку, щоб побачити форму пошуку пакетів.",
                    "mainPkgFormTitle": "Форма пошуку пакетів", "mainPkgFormDesc": "Вкажіть місто відправлення, напрямок, дати подорожі та конфігурацію номерів. Кожне поле допомагає знайти найбільш підходящі варіанти для ваших клієнтів.",
                    "mainFltTabTitle": "Авіаквитки", "mainFltTabDesc": "Шукайте окремі рейси — в один бік або туди-назад. Натисніть цю вкладку, щоб побачити форму пошуку рейсів.",
                    "mainFltFormTitle": "Форма пошуку рейсів", "mainFltFormDesc": "Виберіть тип рейсу, міста відправлення та прибуття, дати та кількість пасажирів. Увімкніть 'Лише прямі рейси', щоб виключити пересадки.",
                    "mainHtlTabTitle": "Готелі", "mainHtlTabDesc": "Шукайте готелі по всьому світу без пакетного туру. Натисніть цю вкладку, щоб побачити форму пошуку готелів.",
                    "mainHtlFormTitle": "Форма пошуку готелів", "mainHtlFormDesc": "Введіть напрямок, дати заїзду та виїзду та конфігурацію номерів. Додавайте кілька номерів і налаштовуйте кожен окремо відповідно до вашої групи.",
                    "mainAttrTabTitle": "Визначні місця", "mainAttrTabDesc": "Відкривайте місцеві визначні місця, екскурсії та розваги в будь-якому напрямку. Натисніть цю вкладку, щоб побачити форму пошуку.",
                    "mainAttrFormTitle": "Форма пошуку визначних місць", "mainAttrFormDesc": "Виберіть місто, діапазон дат та тип активності для пошуку доступних занять. Чудово підходить для доповнень до будь-якого бронювання.",
                    "mainEvtTabTitle": "Заходи", "mainEvtTabDesc": "Бронюйте квитки на концерти, спортивні матчі, фестивалі та інше — з можливістю повного пакету з рейсом і готелем. Натисніть цю вкладку для форми пошуку.",
                    "mainEvtFormTitle": "Форма пошуку заходів", "mainEvtFormDesc": "Шукайте заходи за назвою або напрямком і встановлюйте дати. Увімкніть 'Повний пакет', щоб об'єднати захід з рейсом і готелем в одному бронюванні.",
                    "dynDpSwitchTitle": "Рейс + готель — динамічний пакет", "dynDpSwitchDesc": "Динамічні пакети поєднують обраний вами готель з найдешевшим доступним рейсом за маршрутом — формуючи конкурентну повну ціну пакету на місці. Система автоматично фіксує найкращу ціну рейсу та об'єднує її з результатами по готелях.",
                    "dynDirectTitle": "Прямий рейс", "dynDirectDesc": "При увімкненні результати обмежуються лише прямими рейсами. Вимкніть, щоб включити рейси з пересадками.",
                    "dynDepartureTitle": "Місто відправлення", "dynDepartureDesc": "Оберіть аеропорт або місто, з якого ви будете летіти у рамках динамічного пакету.",
                    "dynDestTitle": "Напрямок або назва готелю", "dynDestDesc": "Шукайте за містом призначення, щоб переглянути всі доступні готелі в районі — або введіть назву конкретного готелю, щоб перейти безпосередньо до нього. Прямий перехід до готелю швидший, коли клієнт вже має перевагу, і допомагає побудувати найкращий пакет за секунди.",
                    "dynDatesTitle": "Дати перебування", "dynDatesDesc": "Виберіть дати заїзду та виїзду з готелю.",
                    "dynGuestsTitle": "Номери та гості", "dynGuestsDesc": "Додавайте скільки завгодно кімнат і налаштовуйте кожну окремо — вкажіть кількість дорослих, дітей та немовлят для кожної кімнати. Поєднуйте конфігурації під склад групи клієнта: наприклад, сім'я з дітьми в одній кімнаті і пара в іншій.",
                    "dynSearchTitle": "Пошук динамічного пакету", "dynSearchDesc": "Натисніть для пошуку доступних динамічних пакетів за вибраним напрямком, датами та гостями.",
                    "fltSearchActionTitle": "Знайти рейс", "fltSearchActionDesc": "Заповніть дані про подорож і натисніть Знайти для перегляду доступних рейсів.",
                    "fltResOnewayDayTitle": "Швидка навігація за датами", "fltResOnewayDayDesc": "Використовуйте картки днів для швидкого переходу до іншої дати вильоту з оновленими цінами.",
                    "fltResOnewayFiltersTitle": "Фільтрувати результати", "fltResOnewayFiltersDesc": "Використовуйте бічні фільтри для звуження результатів за авіакомпанією, ціновим діапазоном, кількістю пересадок і часами рейсів.",
                    "fltResOnewayCardsTitle": "Доступні рейси", "fltResOnewayCardsDesc": "Перегляньте список доступних рейсів. Кожна картка показує авіакомпанію, номер рейсу, тривалість, пересадки і ціну.",
                    "fltResOnewayActionTitle": "Оберіть рейс", "fltResOnewayActionDesc": "Натисніть «Вибрати рейс» на будь-якій картці для переходу на сторінку деталей бронювання.",
                    "fltResBundleTabTitle": "Туди-назад vs Динамічний", "fltResBundleTabDesc": "Перемикайтеся між «Оберіть рейси самостійно» — включаючи гнучкі односторонні сегменти та навігацію за датами — і «Попередньо визначені рейси» — пакети туди-назад.",
                    "fltResBundleFiltersTitle": "Фільтрувати результати", "fltResBundleFiltersDesc": "Використовуйте бічні фільтри для звуження результатів за авіакомпанією, ціновим діапазоном, кількістю пересадок і часами рейсів.",
                    "fltResBundleCardsTitle": "Варіанти пакетних рейсів", "fltResBundleCardsDesc": "Кожна картка показує повний рейс туди-назад з деталями і загальною вартістю.",
                    "fltResBundleActionTitle": "Перейти до замовлення", "fltResBundleActionDesc": "Натисніть «Перейти до замовлення» на вибраному рейсі для перегляду деталей і додавання до кошика.",
                    "fltResBundleResumeActionTitle": "Перейти до замовлення", "fltResBundleResumeActionDesc": "Оберіть пакетний рейс і натисніть «Перейти до замовлення» для продовження.",
                    "fltResDynDayTitle": "Швидка навігація за датами", "fltResDynDayDesc": "Використовуйте картки дат для швидкого переходу до іншої дати вильоту та перегляду змін цін.",
                    "fltResDynFiltersTitle": "Фільтри", "fltResDynFiltersDesc": "Звужуйте результати за авіакомпанією, пересадками, ціновим діапазоном і часами рейсів.",
                    "fltResDynOutboundTitle": "Рейси туди", "fltResDynOutboundDesc": "Переглядайте доступні рейси туди. Кожна картка показує авіакомпанію, маршрут, час і ціну на пасажира.",
                    "fltResDynOutboundActionTitle": "Обрати рейс туди", "fltResDynOutboundActionDesc": "Натисніть «Вибрати рейс» на картці бажаного рейсу, щоб зафіксувати його.",
                    "fltResDynReturnTitle": "Зворотні рейси", "fltResDynReturnDesc": "Тепер оберіть зворотний рейс. Перегляньте всі доступні варіанти для повернення.",
                    "fltResDynReturnActionTitle": "Обрати зворотний рейс", "fltResDynReturnActionDesc": "Натисніть «Вибрати рейс», щоб зафіксувати зворотний перельот.",
                    "fltResDynFinalTitle": "Обрані рейси", "fltResDynFinalDesc": "Обидва рейси обрано. Перевірте загальну ціну перед продовженням.",
                    "fltResDynFinalActionTitle": "Перейти до замовлення", "fltResDynFinalActionDesc": "Натисніть «Перейти до замовлення» для перегляду повних деталей бронювання.",
                    "fltViewAgentCommTitle": "Комісія агента",
                    "fltViewAgentCommDesc": "Перегляньте пропоновану комісію агента для цього рейсу перед додаванням до кошика.",
                    "fltViewCardTitle": "Деталі рейсу", "fltViewCardDesc": "Перегляньте повну інформацію про рейс — авіакомпанія, маршрут, час, пересадки і варіанти багажу — перед бронюванням.",
                    "fltViewPriceTitle": "Зведення ціни", "fltViewPriceDesc": "Загальна вартість показана на пасажира і загальним підсумком. Агенти можуть встановити комісію перед додаванням до кошика.",
                    "fltViewTcTitle": "Умови та обмеження", "fltViewTcDesc": "Перегляньте правила тарифу і умови скасування — включно з важливими обмеженнями — перед додаванням до кошика.",
                    "fltViewActionTitle": "Додати до кошика", "fltViewActionDesc": "Натисніть «Додати до кошика» для бронювання рейсу. Кошик відкриється для перегляду перед оплатою.",
                    "fltCartProductsTitle": "Ваш кошик", "fltCartProductsDesc": "Кошик може містити кілька товарів будь-якого типу — рейси, готелі, пакети та більше. Ви можете додати стільки позицій, скільки потрібно, в одне замовлення. Перевірте всі додані товари тут перед тим як продовжити.",
                    "fltCartItemsTitle": "Товари в кошику", "fltCartItemsDesc": "Кожен товар у кошику вказаний тут — деталі рейсу, тип номера, дати та розподіл пасажирів. Переконайтеся, що всі позиції правильні перед збереженням або продовженням.",
                    "fltCartManageBaggageTitle": "Управління багажем", "fltCartManageBaggageDesc": "Натисніть цю кнопку для управління багажем кожного пасажира — додайте додатковий багаж або налаштуйте параметри для рейсів туди та назад окремо.",
                    "fltCartDiamondsTitle": "Бонусні діаманти", "fltCartDiamondsDesc": "Кількість діамантів показує кешбек-винагороду, яку ви отримаєте за це бронювання.",
                    "fltCartAgentTitle": "Налаштування агента", "fltCartAgentDesc": "Як агент, ви маєте повний контроль над своєю комісією в цьому замовленні. Встановіть відсоток від загальної суми або фіксовану суму на особу — ви самі вирішуєте, скільки заробляти на кожному бронюванні.",
                    "fltCartAgentProfitBtnTitle": "Змінити прибуток", "fltCartAgentProfitBtnDesc": "Натисніть цю кнопку, щоб відкрити налаштування прибутку і змінити розрахунок комісії.",
                    "fltCartAgentProfitInputsTitle": "Налаштування прибутку", "fltCartAgentProfitInputsDesc": "Введіть відсоток від загальної вартості або фіксовану суму на особу. Система застосовує активний режим.",
                    "fltCartAgentSendBtnTitle": "Надіслати пропозицію", "fltCartAgentSendBtnDesc": "Щоб отримати посилання на живу пропозицію: спочатку призначте клієнта до замовлення, потім натисніть «Зберегти пропозицію» — це створює посилання. Після збереження натисніть цю кнопку, щоб відкрити панель «Надіслати пропозицію», де можна скопіювати живе посилання, надіслати його через WhatsApp або поділитися електронною поштою. Живе посилання дає клієнту перегляд замовлення в реальному часі з актуальними цінами.",
                    "fltCartAssignCustomerTitle": "Призначте клієнта", "fltCartAssignCustomerDesc": "Натисніть кнопку «Призначити клієнта», щоб відкрити форму даних клієнта та прив'язати його до цього замовлення.",
                    "fltCartAssignModalTitle": "Заповніть дані клієнта", "fltCartAssignModalDesc": "Заповніть обов'язкові поля — ім'я, телефон, email — і натисніть «Зберегти клієнта», щоб прив'язати його до цього замовлення. Вікно закриється автоматично після збереження.",
                    "fltCartCustomerTitle": "Прив'язаний клієнт", "fltCartCustomerDesc": "Призначений клієнт відображається тут. З прив'язаним клієнтом можна зберегти замовлення та поділитися посиланням на живу пропозицію — або оформити замовлення від його імені.",
                    "fltCartCreateOrderTitle": "Зберегти і поділитися пропозицією", "fltCartCreateOrderDesc": "Натисніть «Зберегти пропозицію», коли будете готові — це доступно лише після призначення клієнта. Після збереження створюється посилання на живу пропозицію: коли клієнт відкриває її, ціни оновлюються автоматично і доступність відображається в реальному часі. При бажанні можна надіслати пропозицію і без живого посилання.",
                    "fltCartComparePriceTitle": "Порівняти ціни", "fltCartComparePriceDesc": "Натисніть, щоб порівняти ціну рейсу в інших постачальників і знайти найвигідніший варіант.",
                    "fltCartTotalTitle": "Загальна ціна", "fltCartTotalDesc": "Загальна ціна показана тут — включаючи всі товари та вашу комісію. Коли будете готові, збережіть замовлення як пропозицію для клієнта або натисніть «Перейти до оплати» для переходу до оформлення.",
                    "fltCartActionTitle": "Перейти до оплати", "fltCartActionDesc": "Натисніть «Перейти до оплати» для оформлення замовлення і заповнення даних пасажирів.",
                    "fltCartSaveOfferActionTitle": "Збережіть пропозицію, щоб завершити", "fltCartSaveOfferActionDesc": "Натисніть «Зберегти пропозицію», щоб створити живе посилання на пропозицію та завершити цей крок. Ви можете поділитися посиланням із клієнтом у будь-який час — ціни та наявність оновлюються в реальному часі.",
                    "fltCheckoutCartTitle": "Зведення замовлення", "fltCheckoutCartDesc": "Ліва панель показує вибраний рейс і загальну суму до сплати.",
                    "fltCheckoutCustomerInfoTitle": "Інформація про клієнта", "fltCheckoutCustomerInfoDesc": "Заповніть особисті дані замовника в цьому розділі.",
                    "fltCheckoutFirstNameTitle": "Ім'я", "fltCheckoutFirstNameDesc": "Введіть ім'я замовника точно як у посвідченні особи або паспорті.",
                    "fltCheckoutLastNameTitle": "Прізвище", "fltCheckoutLastNameDesc": "Введіть прізвище замовника точно як у посвідченні особи або паспорті.",
                    "fltCheckoutPhoneTitle": "Номер телефону", "fltCheckoutPhoneDesc": "Дійсний номер телефону потрібен для надсилання підтвердження замовнику.",
                    "fltCheckoutEmailTitle": "Електронна пошта", "fltCheckoutEmailDesc": "Введіть email замовника для отримання підтвердження бронювання та електронних квитків.",
                    "fltCheckoutGuestInfoTitle": "Дані пасажирів", "fltCheckoutGuestInfoDesc": "Введіть повне ім'я, номер паспорта і дату народження кожного пасажира точно як у паспорті.",
                    "fltCheckoutTCTitle": "Умови та згода", "fltCheckoutTCDesc": "Прочитайте і прийміть умови бронювання перед надсиланням замовлення.",
                    "fltCheckoutFormTitle": "Дані пасажирів", "fltCheckoutFormDesc": "Введіть повне ім'я, номер паспорта і дату народження кожного пасажира точно як у паспорті.",
                    "fltCheckoutActionTitle": "Підтвердити замовлення", "fltCheckoutActionDesc": "Натисніть «Надіслати і перейти до оплати» для підтвердження даних пасажирів і переходу до оплати.",
                    "abBannerTitle": "Панель агента",
                    "abBannerDesc": "Ця смуга у верхній частині B2C — ваша ексклюзивна панель управління агента. Вона надає швидкий доступ до управління клієнтами, налаштувань ціноутворення, балансу Diamonds та облікового запису.",
                    "abExchangeTitle": "Курси валют у реальному часі",
                    "abExchangeDesc": "Актуальні курси валют відображаються тут для швидкої довідки при роботі з бронюваннями у різних валютах.",
                    "abOnboardingBtnTitle": "Посібник з онбордингу",
                    "abOnboardingBtnDesc": "Натисніть на значок питання в будь-який момент, щоб знову відкрити посібник з онбордингу і повернутися до будь-якого кроку.",
                    "abSwitchersTitle": "Перемикачі режиму роботи",
                    "abSwitchersDesc": "Два перемикачі: режим агента/клієнта — у режимі агента видно опції комісії та ціни тільки для агентів. Ціна брутто/нетто — перемикання між роздрібною та чистою ціною.",
                    "abCustomerSearchTitle": "Пошук клієнта",
                    "abCustomerSearchDesc": "Шукайте існуючого клієнта за ім'ям або даними. Вибір клієнта прив'язує його до поточного бронювання, щоб замовлення відображалось у його обліковому записі та керувалось з бек-офісу.",
                    "abUpgradePlanTitle": "Оновити тариф",
                    "abUpgradePlanDesc": "Ця кнопка з'являється, коли агентство на тарифі Light або Regular. Натисніть, щоб відкрити діалог оновлення тарифу і розблокувати розширені функції.",
                    "abDiamondsTitle": "Баланс Diamonds",
                    "abDiamondsDesc": "Ваш кешбек-баланс у Diamonds відображається тут. Сума включає підтверджені доходи плюс майбутні очікувані винагороди. Наведіть курсор для деталізації.",
                    "abUserMenuTitle": "Ваш обліковий запис",
                    "abUserMenuDesc": "Натисніть на своє ім'я, щоб відкрити меню облікового запису — перегляд профілю, статусу тарифу агентства та вихід із системи. Натисніть «Завершити» для виконання цього кроку.",
                    "pkgResSearchActionTitle": "Знайти пакет",
                    "pkgResSearchActionDesc": "Заповніть деталі подорожі вище та натисніть Пошук, щоб побачити доступні пакети.",
                    "pkgResOverviewTitle": "Результати пошуку",
                    "pkgResOverviewDesc": "Тут ви бачите всі доступні пакети, що відповідають вашому запиту. Кожна картка показує готель, дати, ціну та включені рейси.",
                    "pkgResSideFiltersTitle": "Фільтрація результатів",
                    "pkgResSideFiltersDesc": "Використовуйте бокові фільтри для звуження результатів за ціною, напрямком, зірковістю готелю та іншими параметрами.",
                    "pkgResCardTitle": "Картка пакету",
                    "pkgResCardDesc": "Кожна картка показує назву готелю, дати поїздки, рейси, включені додатки та ціну на особу. Натисніть «До замовлення» для перегляду повних деталей.",
                    "pkgResActionTitle": "Відкрити деталі пакету",
                    "pkgResActionDesc": "Натисніть «До замовлення» на будь-якій картці пакету, щоб відкрити повні деталі в новій вкладці та обрати номер.",
                    "pkgPageHotelTitle": "Інформація про готель",
                    "pkgPageHotelDesc": "Цей розділ показує все про готель у пакеті — фотографії, назву, зірковий рейтинг і дати бронювання.",
                    "pkgPageGalleryTitle": "Фотографії готелю",
                    "pkgPageGalleryDesc": "Перегляньте галерею готелю — натисніть на будь-яке фото для відкриття повноекранного перегляду всіх зображень.",
                    "pkgPageDetailsTitle": "Назва та рейтинг готелю",
                    "pkgPageDetailsDesc": "Тут можна побачити назву готелю, напрямок, кількість зірок, дати поїздки та загальну тривалість перебування.",
                    "pkgPageIncludesTitle": "Що входить у пакет",
                    "pkgPageIncludesDesc": "У цій області перераховано все, що включено у вартість пакету — авіаквитки, трансфери, заходи та квитки на події.",
                    "pkgPageFlightsTitle": "Деталі рейсу",
                    "pkgPageFlightsDesc": "У цьому розділі показані рейси туди і назад, включені до пакету — авіакомпанія, час і маршрут.",
                    "pkgPageRoomsTitle": "Вибір номера",
                    "pkgPageRoomsDesc": "Нижче представлені всі доступні типи номерів для цього пакету. Порівняйте варіанти за ціною, типом харчування та особливостями номера.",
                    "pkgPageRoomFiltersTitle": "Фільтри номерів",
                    "pkgPageRoomFiltersDesc": "Використовуйте ці фільтри для звуження варіантів за кількістю гостей, типом харчування (сніданок, напівпансіон, все включено) або назвою номера.",
                    "pkgPageRoomCardTitle": "Картка номера",
                    "pkgPageRoomCardDesc": "Кожна картка містить фото, назву номера та доступні зручності. Прокрутіть вниз для перегляду всіх рядків з цінами.",
                    "pkgPageRoomPriceTitle": "Ціна та тип харчування",
                    "pkgPageRoomPriceDesc": "Кожен рядок показує план харчування, політику скасування, що включено та загальну ціну. Виберіть варіант, який найкраще підходить для клієнта.",
                    "pkgPageAddToCartTitle": "Додати номер до кошика",
                    "pkgPageAddToCartDesc": "Натисніть «Додати до замовлення» на обраному номері, щоб додати цей пакет до кошика та продовжити до оплати.",
                    "moOrderIdTitle": "Номер замовлення",
                    "moOrderIdDesc": "Номер вашого замовлення відображається тут. Використовуйте його для швидкого посилання на це бронювання при зверненні до підтримки або відстеженні.",
                    "moCartOverviewTitle": "Зведення бронювання",
                    "moCartOverviewDesc": "Ліва панель показує повне зведення вашого бронювання — всі заброньовані продукти, розбивку цін та доступні дії.",
                    "moCartProductsTitle": "Заброньовані продукти",
                    "moCartProductsDesc": "Кожен елемент вашого замовлення перелічено тут — деталі рейсу, тип кімнати, дати та кількість пасажирів. Перевірте всі продукти перед внесенням змін.",
                    "moCartAgentTitle": "Опції агента",
                    "moCartAgentDesc": "Як агент, ви можете скоригувати свою комісію за цим замовленням — встановіть відсоток або фіксовану суму на людину. Зміни оновлюють підсумкову ціну, що відображається клієнту.",
                    "moCartTotalTitle": "Загальна сума замовлення",
                    "moCartTotalDesc": "Загальна сума до оплати відображається внизу кошика. Перевірте її уважно — вона відображає всі продукти плюс застосовану комісію агента.",
                    "moTitleAreaTitle": "Дії на сторінці",
                    "moTitleAreaDesc": "Верхня частина форми показує заголовок сторінки. Кнопка «Перейти до оплати» дозволяє перейти до кроку оплати після перегляду та оновлення деталей замовлення.",
                    "moPaymentBtnTitle": "Перейти до оплати",
                    "moPaymentBtnDesc": "Натисніть цю кнопку, коли деталі замовлення повні та правильні. Вас буде перенаправлено до розділу оплати, де ви зможете вибрати спосіб оплати та завершити бронювання.",
                    "moFormTitle": "Форма деталей замовлення",
                    "moFormDesc": "Ця форма дозволяє переглядати та оновлювати всі деталі замовлення — інформацію про клієнта, імена гостей, дані паспорта та особливі прохання. Заповніть всі обов'язкові поля перед переходом до оплати."
                },
                "guideExplorer": {
                    "title": "Провідник по функціях",
                    "subtitle": "Досліджуйте функції у своєму темпі",
                    "startBtn": "Почати",
                    "doneLabel": "Виконано",
                    "noSiteTooltip": "Потрібен налаштований сайт",
                    "timesCompleted": "разів виконано",
                    "filtersTitle": "Фільтри"
                },
            },
            "bot": {
                "title": "Туристичний помічник Sky360",
                "newChat": "Новий чат",
                "previewCart": "Перегляд кошика",
                "addingToCart": "Додаємо до кошика…",
                "collapsed": {
                    "youChose": "Ваш вибір:",
                    "yourPick": "Ваш вибір",
                    "title": {
                        "flight": "Варіанти рейсів",
                        "hotel": "Варіанти готелів",
                        "package": "Варіанти пакетів",
                        "activity": "Варіанти екскурсій",
                        "event": "Варіанти подій",
                        "room": "Варіанти номерів"
                    }
                },
                "blocked": "Цей чат вимкнено.",
                "reconnecting": "Перепідключення…",
                "connectionError": "Помилка з'єднання — повторна спроба…",
                "emptyState": {
                    "title": "Як я можу допомогти спланувати вашу подорож?",
                    "subtitle": "Запитайте мене про рейси, готелі, пакети або активності.",
                    "subtitlePrefix": "Запитайте мене про ",
                    "productNoun": {
                        "flight": "рейси",
                        "hotel": "готелі",
                        "package": "пакети",
                        "activity": "активності",
                        "event": "події"
                    }
                },
                "input": {
                    "placeholder": "Запитайте мене будь-що про вашу подорож…",
                    "disabled": "Чат вимкнено"
                },
                "itinerary": {
                    "titleOne": "1 позиція · {{total}}",
                    "titleOther": "{{count}} позиції · {{total}}",
                    "total": "Разом",
                    "remove": "Видалити"
                },
                "checkout": {
                    "title": "Ваш маршрут",
                    "travellers": "Мандрівники",
                    "total": "Разом",
                    "confirmBook": "Підтвердити та замовити",
                    "completeBooking": "Завершити бронювання"
                },
                "result": {
                    "select": "Обрати",
                    "direct": "Прямий",
                    "stopsOne": "1 зупинка",
                    "stopsOther": "{{count}} зупинки",
                    "freeCancellation": "Безкоштовне скасування",
                    "return": "Повернення",
                    "nights": "ночей",
                    "perNight": "/ніч"
                }
            },
            "changeApproval": {
                "greeting": "Привіт",
                "subtitle": "Ваш рейс було змінено",
                "changeTableTitle": "Деталі зміни",
                "colField": "Поле",
                "colBefore": "До",
                "colAfter": "Після",
                "confirmPrompt": "Будь ласка, підтвердіть, що ви знаєте про цю зміну у вашому бронюванні.",
                "confirmBtn": "Підтвердити зміну",
                "declineBtn": "Відхилити",
                "expiresLabel": "Діє до",
                "expiresIn": "Посилання закінчується через",
                "confirmedTitle": "Зміну підтверджено",
                "confirmedMsg": "Ви підтвердили цю зміну",
                "declinedTitle": "Зміну відхилено",
                "declinedMsg": "Ви відхилили зміну. Наша команда зв'яжеться з вами.",
                "expiredTitle": "Посилання застаріло",
                "expiredMsg": "Термін дії цього посилання закінчився. Будь ласка, зверніться до підтримки.",
                "failedTitle": "Посилання недоступне",
                "failedMsg": "Це посилання недоступне. Будь ласка, зверніться до підтримки.",
                "errorBanner": "Сталася помилка. Будь ласка, спробуйте ще раз.",
                "loading": "Завантаження...",
                "orderLabel": "Замовлення",
                "days": "дн.",
                "hours": "год.",
                "minutes": "хв."
            }
        }
    }
};

export default translationsUk;